import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import Config from '../../config/config';
import { refreshAccessToken } from '../Authorization/authSlice';
const serverPath = Config.serverPath;

//UPLOAD-ADD QUIZ IMG

export const idQuestionsCreate = createAsyncThunk(
    "admin/idQuestionsCreate", async(item, thunkApi) => {
       console.log(item);
       const {dispatch} = thunkApi;
        const url = serverPath + "/api/question/";
        const urlToFetch = `${url}`;
        const response = await fetch(urlToFetch, {
            method: 'POST',
          headers: {
          //"Content-Type": "multipart/form-data  ",
          "Authorization": `Bearer ${localStorage.getItem('token')}`,
        },
            body: item,
            credentials: 'include',
            mode: 'cors',
        });
        
        if (response.ok) {
            const answer = await response.json();
            console.log('Успех ADD QUESTION:', JSON.stringify(answer));
           console.log(answer);
           
            return answer[0];
        }
        //REFRESH ACCESS TOKEN IF 401

        else if (response.status === 401) {
          
            console.log('401 -refresh access token!');
            try {
                const result = await dispatch(refreshAccessToken());
              //IF ACCESS AND REFRESH TOKEN BAD
                console.log(result.payload);
                if (result.payload) {
                   // console.log('GOOD ACCESS!!!!');
                  dispatch(uploadQuizImg(item));
                } else {
                    console.log('Bad refresh access');
                }
            } catch (e) {
                console.log('Error');
            };
        
        } else {
    
           const answer = await response.json();
            console.log(answer.message);
    
            console.log(response);
            return response.status;
           // console.log(response.status);
           // console.log(response)
        }
    
    
    }
    );
//UPLOAD-ADD QUIZ IMG

export const uploadQuizImg = createAsyncThunk(
    "admin/uploadQuizImg", async(item, thunkApi) => {
       console.log(item);
       const {dispatch} = thunkApi;
        const url = serverPath + "/api/uploadsquizimg/";
        const urlToFetch = `${url}`;
        const response = await fetch(urlToFetch, {
            method: 'POST',
          headers: {
          //"Content-Type": "multipart/form-data  ",
          "Authorization": `Bearer ${localStorage.getItem('token')}`,
        },
            body: item,
            credentials: 'include',
            mode: 'cors',
        });
        
        if (response.ok) {
            const answer = await response.json();
            console.log('Успех Upload Quiz img:', JSON.stringify(answer));
           console.log(answer);
           
            return answer[0];
        }
        //REFRESH ACCESS TOKEN IF 401

        else if (response.status === 401) {
          
            console.log('401 -refresh access token!');
            try {
                const result = await dispatch(refreshAccessToken());
              //IF ACCESS AND REFRESH TOKEN BAD
                console.log(result.payload);
                if (result.payload) {
                   // console.log('GOOD ACCESS!!!!');
                  dispatch(uploadQuizImg(item));
                } else {
                    console.log('Bad refresh access');
                }
            } catch (e) {
                console.log('Error');
            };
        
        } else {
    
           const answer = await response.json();
            console.log(answer.message);
    
            console.log(response);
            return response.status;
           // console.log(response.status);
           // console.log(response)
        }
    
    
    }
    );
// GET ALL QUIZES
export const allQizesLoad = createAsyncThunk(
    "admin/allAdminLoad", async(id, thunkApi) => {
        const {dispatch} = thunkApi;
        const url = serverPath + "/api/quizes/";
        const urlToFetch = url;
        const response = await fetch(urlToFetch, {
            method: 'GET',
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Authorization": `Bearer ${localStorage.getItem('token')}`,
            },
           
            credentials: 'include',
            mode: 'cors',
        });
        console.log(response);
        let dataQuizes = [];
        if (response.ok) {
            const jsonResponse = await response.json();
            dataQuizes = jsonResponse;
            console.log(jsonResponse);
            return dataQuizes;
        }else if (response.status === 401) {
                  
            console.log('401 -refresh access token!');
            try {
                const result = await dispatch(refreshAccessToken());
              //IF ACCESS AND REFRESH TOKEN BAD
                console.log(result.payload);
                if (result.payload) {
                   // console.log('GOOD ACCESS!!!!');
                  dispatch(allQizesLoad());
                } else {
                    console.log('Bad refresh access');
                }
            } catch (e) {
                console.log('Error');
            };



        }
        else {
        
        console.log('BAD GET quizes data');
        return response.status;
        } 
        
    }
);
//GET ALL CATEGORIES
export const allCategoriesLoad = createAsyncThunk(
    "admin/allCategoriesLoad", async(id, thunkApi) => {
        const {dispatch} = thunkApi;

        const url = serverPath + "/api/category/";
        const urlToFetch = url;
        const response = await fetch(urlToFetch, {
            method: 'GET',
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Authorization": `Bearer ${localStorage.getItem('token')}`,
            },
           
            credentials: 'include',
            mode: 'cors',
        });
        console.log(response);
        let dataCategories = [];
        if (response.ok) {
            const jsonResponse = await response.json();
            dataCategories = jsonResponse;
           // console.log(jsonResponse);
           return dataCategories;
        } else if (response.status === 401) {
                  
            console.log('401 -refresh access token!');
            try {
                const result = await dispatch(refreshAccessToken());
              //IF ACCESS AND REFRESH TOKEN BAD
                console.log(result.payload);
                if (result.payload) {
                   // console.log('GOOD ACCESS!!!!');
                  dispatch(allCategoriesLoad());
                } else {
                    console.log('Bad refresh access');
                }
            } catch (e) {
                console.log('Error');
            };



        }
        else {
        
        console.log('BAD GET categories data');
        return response.status;
        } 
        
    }
);
//GET ID SUBCATEGORY
export const idSubCategoryLoad = createAsyncThunk(
    "admin/idSubCategoriesLoad", async(item, thunkApi) => {
        const {dispatch} = thunkApi;
        const url = serverPath + "/api/getsubcategory/";
        //const urlToFetch = `${url}${id}/${userId}`;
         const urlToFetch = `${url}`;
        console.log(urlToFetch);
        const response = await fetch(urlToFetch, {
           // method: 'GET',
            method: 'POST',
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Authorization": `Bearer ${localStorage.getItem('token')}`,
            },
            body: JSON.stringify({
                id: item.id,
                user_id: item.userId,
               
            }),
            //credentials: 'include',
           // mode: 'cors',
        });
        console.log(response);
        let dataCategoryId = [];
        if (response.ok) {
            const jsonResponse = await response.json();
            dataCategoryId = jsonResponse;
            console.log(jsonResponse);
            return dataCategoryId;
        }else if (response.status === 401) {
                  
            console.log('401 -refresh access token!');
            try {
                const result = await dispatch(refreshAccessToken());
              //IF ACCESS AND REFRESH TOKEN BAD
                console.log(result.payload);
                if (result.payload) {
                   // console.log('GOOD ACCESS!!!!');
                  dispatch(idSubCategoryLoad(item));
                } else {
                    console.log('Bad refresh access');
                }
            } catch (e) {
                console.log('Error');
            };



        }
        else {
        
        console.log('BAD GET sub cat data');
        return response.status;
        } 
        
    }
);
//GET ID QUIZ
export const idQuizLoad = createAsyncThunk(
    "admin/idQuizLoad", async(id, thunkApi) => {
        const {dispatch} = thunkApi;
        const url = serverPath + "/api/quizes/";
        const urlToFetch = `${url}${id}`;
        const response = await fetch(urlToFetch, {
            method: 'GET',
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Authorization": `Bearer ${localStorage.getItem('token')}`,
            },
           
            credentials: 'include',
            mode: 'cors',
        });
        console.log(response);
        let dataQuizId = [];
        if (response.ok) {
            const jsonResponse = await response.json();
            dataQuizId = jsonResponse;
            console.log(jsonResponse);
            return dataQuizId;
        } else if (response.status === 401) {
          
            console.log('401 -refresh access token!');
            try {
                const result = await dispatch(refreshAccessToken());
              //IF ACCESS AND REFRESH TOKEN BAD
                console.log(result.payload);
                if (result.payload) {
                  dispatch(idQuizLoad(id));
                } else {
                    console.log('Bad refresh access');
                }
            } catch (e) {
                console.log('Error');
            }
        } else {console.log(response);}
       
    }
);

//GET ID QUESTIONS
export const idQuestionsLoad = createAsyncThunk(
    "admin/idQuestionsLoad", async(id, thunkApi) => {
        const url = serverPath + "/api/question/";
        const {dispatch} = thunkApi;
        const urlToFetch = `${url}${id}`;
        const response = await fetch(urlToFetch, {
            method: 'GET',
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Authorization": `Bearer ${localStorage.getItem('token')}`,
            },
           
            credentials: 'include',
            mode: 'cors',
        });
        console.log(response);
        let dataQuestionsId = [];
        if (response.ok) {
            const jsonResponse = await response.json();
            dataQuestionsId = jsonResponse;
            console.log(jsonResponse);
            return dataQuestionsId;
        } else if (response.status === 401) {
          
            console.log('401 -refresh access token!');
            try {
                const result = await dispatch(refreshAccessToken());
              //IF ACCESS AND REFRESH TOKEN BAD
                console.log(result.payload);
                if (result.payload) {
                  dispatch(idQuestionsLoad(id));
                } else {
                    console.log('Bad refresh access');
                }
            } catch (e) {
                console.log('Error');
            }
        } else {console.log(response);}
        
    }
);
//GET ID ANSWERS
export const idAnswersLoad = createAsyncThunk(
    "admin/idAnswersLoad", async(item, thunkApi) => {
        console.log(item.id);
        const {dispatch} = thunkApi;
        const url = serverPath + "/api/answerforquestion/";
        const urlToFetch = `${url}${item.id}/${item.sortQuestion}`;
        const response = await fetch(urlToFetch, {
            method: 'GET',
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Authorization": `Bearer ${localStorage.getItem('token')}`,
            },
           
            credentials: 'include',
            mode: 'cors',
        });
        console.log(response);
        let dataAnswersId = [];
        if (response.ok) {
            const jsonResponse = await response.json();
            dataAnswersId = jsonResponse;
            console.log(jsonResponse);
            return dataAnswersId;
        } else if (response.status === 401) {
          
            console.log('401 -refresh access token!');
            try {
                const result = await dispatch(refreshAccessToken());
              //IF ACCESS AND REFRESH TOKEN BAD
                console.log(result.payload);
                if (result.payload) {
                  dispatch(idAnswersLoad(item));
                } else {
                    console.log('Bad refresh access');
                }
            } catch (e) {
                console.log('Error');
            }
        } else {console.log(response);}
        
    }
);


//UPDATE ID ANSWERS

export const idAnswersUpdate = createAsyncThunk(
    "admin/idAnswersUpdate", async(item, thunkApi) => {
        const {dispatch} = thunkApi;
        console.log(item);
        const url = serverPath + "/api/answer/";
        const urlToFetch = `${url}${item.answer_id}`;
        const response = await fetch(urlToFetch, {
            method: 'PUT',
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Authorization": `Bearer ${localStorage.getItem('token')}`,},
            body: JSON.stringify({
                answer_id: item.answer_id,
                answer_content: item.answer_content,
                answer_value: item.answer_value,
                answer_feedback: item.answer_feedback,
            })
        });
        
         if (response.ok) {
            const answer = await response.json();
           
            console.log('Успех:', JSON.stringify(answer));
            console.log(answer[0]);
           return answer[0];
        } else if (response.status === 401) {
          
            console.log('401 -refresh access token!');
            try {
                const result = await dispatch(refreshAccessToken());
              //IF ACCESS AND REFRESH TOKEN BAD
                console.log(result.payload);
                if (result.payload) {
                  dispatch(idAnswersUpdate(item));
                } else {
                    console.log('Bad refresh access');
                }
            } catch (e) {
                console.log('Error');
            }
        } else {console.log(response);}

    }
);
//UPDATE ID ANSWERS TYPE 2

export const idAnswersUpdateType2 = createAsyncThunk(
    "admin/idAnswersUpdateType2", async(item, thunkApi) => {
        const {dispatch} = thunkApi;
        console.log(item);
        const url = serverPath + "/api/answertype2/";
        const urlToFetch = `${url}${item.answer_id}`;
        const response = await fetch(urlToFetch, {
            method: 'PUT',
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Authorization": `Bearer ${localStorage.getItem('token')}`,},
            body: JSON.stringify({
                answer_id: item.answer_id,
                answer_content: item.answer_content,
                answer_order: item.answer_order,
                
            })
        });
        
         if (response.ok) {
            const answer = await response.json();
           
            console.log('Успех:', JSON.stringify(answer));
            console.log(answer[0]);
           return answer[0];
        } else if (response.status === 401) {
          
            console.log('401 -refresh access token!');
            try {
                const result = await dispatch(refreshAccessToken());
              //IF ACCESS AND REFRESH TOKEN BAD
                console.log(result.payload);
                if (result.payload) {
                  dispatch(idAnswersUpdateType2(item));
                } else {
                    console.log('Bad refresh access');
                }
            } catch (e) {
                console.log('Error');
            }
        } else {console.log(response);}

    }
);
//UPDATE ID ANSWERS TYPE 3

export const idAnswersUpdateType3 = createAsyncThunk(
    "admin/idAnswersUpdateType3", async(item, thunkApi) => {
        const {dispatch} = thunkApi;
        console.log(item);
        const url = serverPath + "/api/answertype3/";
        const urlToFetch = `${url}${item.answer_id}`;
        const response = await fetch(urlToFetch, {
            method: 'PUT',
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Authorization": `Bearer ${localStorage.getItem('token')}`,},
            body: JSON.stringify({
                answer_id: item.answer_id,
                answer_content: item.answer_content,
                answer_right: item.answer_right,
                
            })
        });
        
         if (response.ok) {
            const answer = await response.json();
           
            console.log('Успех:', JSON.stringify(answer));
            console.log(answer[0]);
           return answer[0];
        } else if (response.status === 401) {
          
            console.log('401 -refresh access token!');
            try {
                const result = await dispatch(refreshAccessToken());
              //IF ACCESS AND REFRESH TOKEN BAD
                console.log(result.payload);
                if (result.payload) {
                  dispatch(idAnswersUpdateType3(item));
                } else {
                    console.log('Bad refresh access');
                }
            } catch (e) {
                console.log('Error');
            }
        } else {console.log(response);}

    }
);
//UPDATE ID ANSWERS TYPE 4

export const idAnswersUpdateType4 = createAsyncThunk(
    "admin/idAnswersUpdateType4", async(item, thunkApi) => {
        const {dispatch} = thunkApi;
        console.log(item);
        const url = serverPath + "/api/answertype4/";
        const urlToFetch = `${url}${item.answer_id}`;
        const response = await fetch(urlToFetch, {
            method: 'PUT',
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Authorization": `Bearer ${localStorage.getItem('token')}`,},
            body: JSON.stringify({
                answer_id: item.answer_id,
                content_compare: item.content_compare,
                content_source: item.content_source,
                
            })
        });
        
         if (response.ok) {
            const answer = await response.json();
           
            console.log('Успех:', JSON.stringify(answer));
            console.log(answer[0]);
           return answer[0];
        } else if (response.status === 401) {
          
            console.log('401 -refresh access token!');
            try {
                const result = await dispatch(refreshAccessToken());
              //IF ACCESS AND REFRESH TOKEN BAD
                console.log(result.payload);
                if (result.payload) {
                  dispatch(idAnswersUpdateType4(item));
                } else {
                    console.log('Bad refresh access');
                }
            } catch (e) {
                console.log('Error');
            }
        } else {console.log(response);}

    }
);
//CREATE ID ANSWERS
export const idAnswersCreate = createAsyncThunk( 
    "admin/idAnswersCreate", async(item, thunkApi) => {
        const {dispatch} = thunkApi;
        console.log(item);
        const url = serverPath + "/api/answer/";
        const urlToFetch = `${url}`;
        const response = await fetch(urlToFetch, {
            method: 'POST',
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Authorization": `Bearer ${localStorage.getItem('token')}`,},
            body: JSON.stringify({
                answer_content: item.answer_content,
                answer_feedback: item.answer_feedback,
                answer_value: item.answer_value,
                question_id: item.question_id,
                quiz_id: item.quiz_id
            })
        });
        
         if (response.ok) {
            const answer = await response.json();
           
            console.log('Успех:', JSON.stringify(answer));
            console.log(answer[0]);
           return answer[0];
        } else if (response.status === 401) {
          
            console.log('401 -refresh access token!');
            try {
                const result = await dispatch(refreshAccessToken());
              //IF ACCESS AND REFRESH TOKEN BAD
                console.log(result.payload);
                if (result.payload) {
                  dispatch(idAnswersCreate(item));
                } else {
                    console.log('Bad refresh access');
                }
            } catch (e) {
                console.log('Error');
            }
        } else {console.log(response);}

    }
);
//CREATE ID ANSWERS FOR TYPE 2
export const idAnswersCreateType2 = createAsyncThunk( 
    "admin/idAnswersCreateType2", async(item, thunkApi) => {
        const {dispatch} = thunkApi;
        console.log(item);
        const url = serverPath + "/api/answertype2/";
        const urlToFetch = `${url}`;
        const response = await fetch(urlToFetch, {
            method: 'POST',
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Authorization": `Bearer ${localStorage.getItem('token')}`,},
            body: JSON.stringify({
                answer_content: item.answer_content,
                answer_order: item.answer_order,
                question_id: item.question_id,
                //quiz_id: item.quiz_id
            })
        });
        
         if (response.ok) {
            const answer = await response.json();
           
            console.log('Успех:', JSON.stringify(answer));
            console.log(answer[0]);
           return answer[0];
        } else if (response.status === 401) {
          
            console.log('401 -refresh access token!');
            try {
                const result = await dispatch(refreshAccessToken());
              //IF ACCESS AND REFRESH TOKEN BAD
                console.log(result.payload);
                if (result.payload) {
                  dispatch(idAnswersCreateType2(item));
                } else {
                    console.log('Bad refresh access');
                }
            } catch (e) {
                console.log('Error');
            }
        } else {console.log(response);}

    }
);
//CREATE ID ANSWERS FOR TYPE 3
export const idAnswersCreateType3 = createAsyncThunk( 
    "admin/idAnswersCreateType3", async(item, thunkApi) => {
        const {dispatch} = thunkApi;
        console.log(item);
        const url = serverPath + "/api/answertype3/";
        const urlToFetch = `${url}`;
        const response = await fetch(urlToFetch, {
            method: 'POST',
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Authorization": `Bearer ${localStorage.getItem('token')}`,},
            body: JSON.stringify({
                answer_content: item.answer_content,
                answer_right: item.answer_right,
                question_id: item.question_id,
                //quiz_id: item.quiz_id
            })
        });
        
         if (response.ok) {
            const answer = await response.json();
           
            console.log('Успех:', JSON.stringify(answer));
            console.log(answer[0]);
           return answer[0];
        } else if (response.status === 401) {
          
            console.log('401 -refresh access token!');
            try {
                const result = await dispatch(refreshAccessToken());
              //IF ACCESS AND REFRESH TOKEN BAD
                console.log(result.payload);
                if (result.payload) {
                  dispatch(idAnswersCreateType3(item));
                } else {
                    console.log('Bad refresh access');
                }
            } catch (e) {
                console.log('Error');
            }
        } else {console.log(response);}

    }
);
//CREATE ID ANSWERS FOR TYPE 4
export const idAnswersCreateType4 = createAsyncThunk( 
    "admin/idAnswersCreateType4", async(item, thunkApi) => {
        const {dispatch} = thunkApi;
        console.log(item);
        const url = serverPath + "/api/answertype4/";
        const urlToFetch = `${url}`;
        const response = await fetch(urlToFetch, {
            method: 'POST',
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Authorization": `Bearer ${localStorage.getItem('token')}`,},
            body: JSON.stringify({
                content_source: item.content_source,
                content_compare: item.content_compare,
                question_id: item.question_id,
                //quiz_id: item.quiz_id
            })
        });
        
         if (response.ok) {
            const answer = await response.json();
           
            console.log('Успех:', JSON.stringify(answer));
            console.log(answer[0]);
           return answer[0];
        } else if (response.status === 401) {
          
            console.log('401 -refresh access token!');
            try {
                const result = await dispatch(refreshAccessToken());
              //IF ACCESS AND REFRESH TOKEN BAD
                console.log(result.payload);
                if (result.payload) {
                  dispatch(idAnswersCreateType4(item));
                } else {
                    console.log('Bad refresh access');
                }
            } catch (e) {
                console.log('Error');
            }
        } else {console.log(response);}

    }
);
//UPDATE ID QUESTIONS
export const idQuestionUpdate = createAsyncThunk(
    "admin/idQuestionUpdate", async(item, thunkApi) => {
        const {dispatch} = thunkApi;
        console.log(item);
        const url = serverPath + "/api/question/";
        const urlToFetch = `${url}${item.question_id}`;
        const response = await fetch(urlToFetch, {
            method: 'PUT',
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Authorization": `Bearer ${localStorage.getItem('token')}`,},
            body: JSON.stringify({
                question_id: item.question_id,
                question_content: item.question_content,
                sort_quest: item.sort_quest
                
            })
        });
        
         if (response.ok) {
            const answer = await response.json();
           
            console.log('Успех:', JSON.stringify(answer));
            console.log(answer[0]);
           return answer[0];
        } else if (response.status === 401) {
          
            console.log('401 -refresh access token!');
            try {
                const result = await dispatch(refreshAccessToken());
              //IF ACCESS AND REFRESH TOKEN BAD
                console.log(result.payload);
                if (result.payload) {
                  dispatch(idQuestionUpdate(item));
                } else {
                    console.log('Bad refresh access');
                }
            } catch (e) {
                console.log('Error');
            }
        } else {console.log(response);}

    }
);
//CREATE ID QUESTIONS OLD
/*
export const idQuestionsCreate = createAsyncThunk(
    "admin/idQuestionsCreate", async(item, thunkApi) => {
        const {dispatch} = thunkApi;
        console.log(item);
        const url = serverPath + "/api/question/";
        const urlToFetch = `${url}`;
        const response = await fetch(urlToFetch, {
            method: 'POST',
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Authorization": `Bearer ${localStorage.getItem('token')}`,},
            body: JSON.stringify({
                question_content: item.question_content,
                quiz_id: item.quiz_id
            })
        });
        
         if (response.ok) {
            const answer = await response.json();
           
            console.log('Успех:', JSON.stringify(answer));
            console.log(answer[0]);
           return answer[0];
        } else if (response.status === 401) {
          
            console.log('401 -refresh access token!');
            try {
                const result = await dispatch(refreshAccessToken());
              //IF ACCESS AND REFRESH TOKEN BAD
                console.log(result.payload);
                if (result.payload) {
                  dispatch(idQuestionsCreate(item));
                } else {
                    console.log('Bad refresh access');
                }
            } catch (e) {
                console.log('Error');
            }
        } else {console.log(response);}

    }
);
*/
//DELETE ID QUESTIONS
export const idQuestionsDelete = createAsyncThunk(
    "admin/idQuestionsDelete", async(item, thunkApi) => {
        const {dispatch} = thunkApi;
        console.log(item);
        const url = serverPath + "/api/question/";
        const urlToFetch = `${url}${item.question_id}`;
        const response = await fetch(urlToFetch, {
            method: 'DELETE',
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Authorization": `Bearer ${localStorage.getItem('token')}`,},
            body: JSON.stringify({
                question_id: item.question_id
                  
            })
        });
        
         if (response.ok) {
            const answer = await response.json();
           
            console.log('Успех:', JSON.stringify(answer));
            console.log(answer[0]);
           return answer[0];
        } else if (response.status === 401) {
          
            console.log('401 -refresh access token!');
            try {
                const result = await dispatch(refreshAccessToken());
              //IF ACCESS AND REFRESH TOKEN BAD
                console.log(result.payload);
                if (result.payload) {
                  dispatch(idQuestionsDelete(item));
                } else {
                    console.log('Bad refresh access');
                }
            } catch (e) {
                console.log('Error');
            }
        } else {console.log(response);}

    }
);
//DELETE  QUESTION IMG
export const imgQuestionDelete = createAsyncThunk(
    "admin/imgQuestionDelete", async(item, thunkApi) => {
        const {dispatch} = thunkApi;
        console.log(item);
        const url = serverPath + "/api/question/";
        const urlToFetch = `${url}${item.quizId}/${item.questionId}/${item.imgName}`;
        const response = await fetch(urlToFetch, {
            method: 'DELETE',
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Authorization": `Bearer ${localStorage.getItem('token')}`,},
           
        });
        
         if (response.ok) {
            const answer = await response.json();
           
            console.log('Успех:', JSON.stringify(answer));
            console.log(answer[0]);
           return answer[0];
        } else if (response.status === 401) {
          
            console.log('401 -refresh access token!');
            try {
                const result = await dispatch(refreshAccessToken());
              //IF ACCESS AND REFRESH TOKEN BAD
                console.log(result.payload);
                if (result.payload) {
                  dispatch(idQuestionsDelete(item));
                } else {
                    console.log('Bad refresh access');
                }
            } catch (e) {
                console.log('Error');
            }
        } else {console.log(response);}

    }
);

//UPDATE ID QUIZES
export const idQuizUpdate = createAsyncThunk(
    "admin/idQuizUpdate", async(item, thunkApi) => {
        const {dispatch} = thunkApi;
        console.log(item);
        const url = serverPath + "/api/quizes/";
        const urlToFetch = `${url}${item.quiz_id}`;
        const response = await fetch(urlToFetch, {
            method: 'PUT',
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Authorization": `Bearer ${localStorage.getItem('token')}`,},
            body: JSON.stringify({
                quiz_id: item.quiz_id,
                quiz_name: item.quiz_name,
                quiz_description: item.quiz_description,
                quiz_category: item.quiz_category,
                quiz_value:item.quiz_value
                
            })
        });
        
         if (response.ok) {
            const answer = await response.json();
           
            console.log('Успех:', JSON.stringify(answer));
            console.log(answer[0]);
           return answer[0];
        } else if (response.status === 401) {
          
            console.log('401 -refresh access token!');
            try {
                const result = await dispatch(refreshAccessToken());
              //IF ACCESS AND REFRESH TOKEN BAD
                console.log(result.payload);
                if (result.payload) {
                  dispatch(idQuizUpdate(item));
                } else {
                    console.log('Bad refresh access');
                }
            } catch (e) {
                console.log('Error');
            }
        } else {console.log(response);}

    }
);
//CREATE ID QUIZES
export const idQuizesCreate = createAsyncThunk(
    "admin/idQuizesCreate", async(item, thunkApi) => {
        const {dispatch} = thunkApi;
        console.log(item);
        const url = serverPath + "/api/quizes/";
        const urlToFetch = `${url}`;
        const response = await fetch(urlToFetch, {
            method: 'POST',
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Authorization": `Bearer ${localStorage.getItem('token')}`,},
            body: JSON.stringify({
                quiz_name: item.quiz_name,
                quiz_description: item.quiz_description,
                sub_id: item.sub_id,
                quiz_category: item.quiz_category,
                quiz_value:item.quiz_value,
                creator_id: item.creator_id,
            })
        });
        
         if (response.ok) {
            const answer = await response.json();
           
            console.log('Успех:', JSON.stringify(answer));
            console.log(answer[0]);
           return answer[0];
        } else if (response.status === 401) {
          
            console.log('401 -refresh access token!');
            try {
                const result = await dispatch(refreshAccessToken());
              //IF ACCESS AND REFRESH TOKEN BAD
                console.log(result.payload);
                if (result.payload) {
                  dispatch(idQuizesCreate(item));
                } else {
                    console.log('Bad refresh access');
                }
            } catch (e) {
                console.log('Error');
            }
        } else {console.log(response);}

    }
);
//DELETE ID QUIZES
export const idQuizesDelete = createAsyncThunk(
    "admin/idQuizesDelete", async(item, thunkApi) => {
        const {dispatch} = thunkApi;
        console.log(item);
        const url = serverPath + "/api/quizes/";
        const urlToFetch = `${url}${item.quiz_id}`;
        const response = await fetch(urlToFetch, {
            method: 'DELETE',
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Authorization": `Bearer ${localStorage.getItem('token')}`,},
            body: JSON.stringify({
                quiz_id: item.quiz_id,
                //main_name: item.main_name
                               
            })
        });
        
         if (response.ok) {
            const answer = await response.json();
           
            console.log('Успех:', JSON.stringify(answer));
            console.log(answer[0]);
           return answer[0];
        } else if (response.status === 401) {
          
            console.log('401 -refresh access token!');
            try {
                const result = await dispatch(refreshAccessToken());
              //IF ACCESS AND REFRESH TOKEN BAD
                console.log(result.payload);
                if (result.payload) {
                  dispatch(idQuizesDelete(item));
                } else {
                    console.log('Bad refresh access');
                }
            } catch (e) {
                console.log('Error');
            }
        } else {console.log(response);}

    }
);
//UPDATE ID SUBCATEGORIES
export const idSubCategoriesUpdate = createAsyncThunk(
    "admin/idSubCategoriesUpdate", async(item, thunkApi) => {
        const {dispatch} = thunkApi;
        console.log(item);
        const url = serverPath + "/api/subcategory/";
        const urlToFetch = `${url}${item.sub_id}`;
        const response = await fetch(urlToFetch, {
            method: 'PUT',
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Authorization": `Bearer ${localStorage.getItem('token')}`,},
            body: JSON.stringify({
                sub_id: item.sub_id,
                sub_name: item.sub_name
                               
            })
        });
        
         if (response.ok) {
            const answer = await response.json();
           
            console.log('Успех:', JSON.stringify(answer));
            console.log(answer[0]);
           return answer[0];
        } else if (response.status === 401) {
          
            console.log('401 -refresh access token!');
            try {
                const result = await dispatch(refreshAccessToken());
              //IF ACCESS AND REFRESH TOKEN BAD
                console.log(result.payload);
                if (result.payload) {
                  dispatch(idSubCategoriesUpdate(item));
                } else {
                    console.log('Bad refresh access');
                }
            } catch (e) {
                console.log('Error');
            }
        } else {console.log(response);}

    }
);
//UPDATE ID CATEGORIES
export const idCategoriesUpdate = createAsyncThunk(
    "admin/idCategoriesUpdate", async(item, thunkApi) => {
        const {dispatch} = thunkApi;
        console.log(item);
        const url = serverPath + "/api/category/";
        const urlToFetch = `${url}${item.main_id}`;
        const response = await fetch(urlToFetch, {
            method: 'PUT',
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Authorization": `Bearer ${localStorage.getItem('token')}`,},
            body: JSON.stringify({
                main_id: item.main_id,
                main_name: item.main_name
                               
            })
        });
        
         if (response.ok) {
            const answer = await response.json();
           
            console.log('Успех:', JSON.stringify(answer));
            console.log(answer[0]);
           return answer[0];
        } else if (response.status === 401) {
          
            console.log('401 -refresh access token!');
            try {
                const result = await dispatch(refreshAccessToken());
              //IF ACCESS AND REFRESH TOKEN BAD
                console.log(result.payload);
                if (result.payload) {
                  dispatch(idCategoriesUpdate(item));
                } else {
                    console.log('Bad refresh access');
                }
            } catch (e) {
                console.log('Error');
            }
        } else {console.log(response);}

    }
);
//CREATE ID CATEGORY
export const idCategoriesCreate = createAsyncThunk(
    "admin/idCategoriesCreate", async(item, thunkApi) => {
        const {dispatch} = thunkApi;
        console.log(item);
        const url = serverPath + "/api/category/";
        const urlToFetch = `${url}`;
        const response = await fetch(urlToFetch, {
            method: 'POST',
            headers: {"Content-Type": "application/json; charset=utf-8",
                "Authorization": `Bearer ${localStorage.getItem('token')}`,
            },
            body: JSON.stringify({
                main_id: item.main_id,
                main_name: item.main_name
                               
            })
        });
        
         if (response.ok) {
            const answer = await response.json();
           
            console.log('Успех:', JSON.stringify(answer));
            console.log(answer[0]);
           return answer[0];
        } //REFRESH ACCESS TOKEN IF 401

        else if (response.status === 401) {
          
            console.log('401 -refresh access token!');
            try {
                const result = await dispatch(refreshAccessToken());
              //IF ACCESS AND REFRESH TOKEN BAD
                console.log(result.payload);
                if (result.payload) {
                  dispatch(idCategoriesCreate(item));
                } else {
                    console.log('Bad refresh access');
                }
            } catch (e) {
                console.log('Error');
            } 
        }
        else {console.log(response);}

    }
);
//CREATE ID SUBCATEGORY
export const idSubCategoriesCreate = createAsyncThunk(
    "admin/idSubCategoriesCreate", async(item, thunkApi) => {
        const {dispatch} = thunkApi;
        console.log(item);
        const url = serverPath + "/api/subcategory/";
        const urlToFetch = `${url}`;
        const response = await fetch(urlToFetch, {
            method: 'POST',
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Authorization": `Bearer ${localStorage.getItem('token')}`,},
            body: JSON.stringify({
                sub_name: item.sub_name,
                main_id: item.main_id,
                user_id: item.user_id
            })
        });
        
         if (response.ok) {
            const answer = await response.json();
           
            console.log('Успех:', JSON.stringify(answer));
            console.log(answer[0]);
           return answer[0];
        } else if (response.status === 401) {
          
            console.log('401 -refresh access token!');
            try {
                const result = await dispatch(refreshAccessToken());
              //IF ACCESS AND REFRESH TOKEN BAD
                console.log(result.payload);
                if (result.payload) {
                  dispatch(idSubCategoriesCreate(item));
                } else {
                    console.log('Bad refresh access');
                }
            } catch (e) {
                console.log('Error');
            }
        } else {console.log(response);}

    }
);
//DELETE ID CATEGORY
export const idCategoriesDelete = createAsyncThunk(
    "admin/idCategoriesDelete", async(item, thunkApi) => {
        const {dispatch} = thunkApi;
        console.log(item);
        const url = serverPath + "/api/category/";
        const urlToFetch = `${url}${item.main_id}`;
        const response = await fetch(urlToFetch, {
            method: 'DELETE',
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Authorization": `Bearer ${localStorage.getItem('token')}`,
            },
            body: JSON.stringify({
                main_id: item.main_id,
                //main_name: item.main_name
                               
            })
        });
        
         if (response.ok) {
            const answer = await response.json();
           
            console.log('Успех:', JSON.stringify(answer));
            console.log(answer[0]);
           return answer[0];
        } else if (response.status === 401) {
          
            console.log('401 -refresh access token!');
            try {
                const result = await dispatch(refreshAccessToken());
              //IF ACCESS AND REFRESH TOKEN BAD
                console.log(result.payload);
                if (result.payload) {
                  dispatch(idCategoriesDelete(item));
                } else {
                    console.log('Bad refresh access');
                }
            } catch (e) {
                console.log('Error');
            }
        } 
        else {console.log(response);}

    }
);
//DELETE ID SUBCATEGORY
export const idSubCategoriesDelete = createAsyncThunk(
    "admin/idSubCategoriesDelete", async(item, thunkApi) => {
        const {dispatch} = thunkApi;
        console.log(item);
        const url = serverPath + "/api/subcategory/";
        const urlToFetch = `${url}${item.sub_id}`;
        const response = await fetch(urlToFetch, {
            method: 'DELETE',
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Authorization": `Bearer ${localStorage.getItem('token')}`,},
            body: JSON.stringify({
                sub_id: item.sub_id,
                //main_name: item.main_name
                               
            })
        });
        
         if (response.ok) {
            const answer = await response.json();
           
            console.log('Успех:', JSON.stringify(answer));
            console.log(answer[0]);
           return answer[0];
        } else if (response.status === 401) {
          
            console.log('401 -refresh access token!');
            try {
                const result = await dispatch(refreshAccessToken());
              //IF ACCESS AND REFRESH TOKEN BAD
                console.log(result.payload);
                if (result.payload) {
                  dispatch(idSubCategoriesDelete(item));
                } else {
                    console.log('Bad refresh access');
                }
            } catch (e) {
                console.log('Error');
            }
        } else {console.log(response);}

    }
);
//DELETE ID ANSWERS
export const idAnswersDelete = createAsyncThunk(
    "admin/idAnswersDelete", async(item, thunkApi) => {
        const {dispatch} = thunkApi;
        console.log(item);
        const url = serverPath + "/api/answer/";
        const urlToFetch = `${url}${item.answer_id}/${item.sortQuestion}`;
        const response = await fetch(urlToFetch, {
            method: 'DELETE',
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Authorization": `Bearer ${localStorage.getItem('token')}`,},
            body: JSON.stringify({
                answer_id: item.answer_id,
                //main_name: item.main_name
                               
            })
        });
        
         if (response.ok) {
            const answer = await response.json();
           
            console.log('Успех:', JSON.stringify(answer));
            console.log(answer[0]);
           return answer[0];
        } else if (response.status === 401) {
          
            console.log('401 -refresh access token!');
            try {
                const result = await dispatch(refreshAccessToken());
              //IF ACCESS AND REFRESH TOKEN BAD
                console.log(result.payload);
                if (result.payload) {
                  dispatch(idAnswersDelete(item));
                } else {
                    console.log('Bad refresh access');
                }
            } catch (e) {
                console.log('Error');
            }
        } else {console.log(response);}

    }
);
//UPLOAD-ADD NOTE PART

export const uploadNotePart = createAsyncThunk(
    "auth/uploadNotePart", async(item, thunkApi) => {
       console.log(item);
       const {dispatch} = thunkApi;
        const url = serverPath + "/api/uploadsnotes/";
        const urlToFetch = `${url}`;
        const response = await fetch(urlToFetch, {
            method: 'POST',
          headers: {
          //"Content-Type": "multipart/form-data  ",
          "Authorization": `Bearer ${localStorage.getItem('token')}`,
        },
            body: item,
            credentials: 'include',
            mode: 'cors',
        });
        
        if (response.ok) {
            const answer = await response.json();
            console.log('Успех Upload Note part:', JSON.stringify(answer));
           console.log(answer);
           
            return answer;
        }
        //REFRESH ACCESS TOKEN IF 401

        else if (response.status === 401) {
          
            console.log('401 -refresh access token!');
            try {
                const result = await dispatch(refreshAccessToken());
              //IF ACCESS AND REFRESH TOKEN BAD
                console.log(result.payload);
                if (result.payload) {
                   // console.log('GOOD ACCESS!!!!');
                  dispatch(uploadNotePart(item));
                } else {
                    console.log('Bad refresh access');
                }
            } catch (e) {
                console.log('Error');
            };
        
        } else {
    
           const answer = await response.json();
            console.log(answer.message);
    
            console.log(response);
            return response.status;
           // console.log(response.status);
           // console.log(response)
        }
    
    
    }
    );
//UPLOAD-ADD NOTE FILES

export const uploadAddNoteFiles = createAsyncThunk(
    "auth/uploadAddNoteFiles", async(item, thunkApi) => {
       console.log(item);
       const {dispatch} = thunkApi;
        const url = serverPath + "/api/uploadaddnotefiles/";
        const urlToFetch = `${url}`;
        const response = await fetch(urlToFetch, {
            method: 'POST',
          headers: {
          //"Content-Type": "multipart/form-data  ",
          "Authorization": `Bearer ${localStorage.getItem('token')}`,
        },
            body: item,
            credentials: 'include',
            mode: 'cors',
        });
        
        if (response.ok) {
            const answer = await response.json();
            console.log('Успех Upload Add Note Files:', JSON.stringify(answer));
           console.log(answer);
           
            return answer;
        }
        //REFRESH ACCESS TOKEN IF 401

        else if (response.status === 401) {
          
            console.log('401 -refresh access token!');
            try {
                const result = await dispatch(refreshAccessToken());
              //IF ACCESS AND REFRESH TOKEN BAD
                console.log(result.payload);
                if (result.payload) {
                   // console.log('GOOD ACCESS!!!!');
                  dispatch(uploadAddNoteFiles(item));
                } else {
                    console.log('Bad refresh access');
                }
            } catch (e) {
                console.log('Error');
            };
        
        } else {
    
           const answer = await response.json();
            console.log(answer.message);
    
            console.log(response);
            return response.status;
           // console.log(response.status);
           // console.log(response)
        }
    
    
    }
    );    
//GET ID NOTE
export const idNoteLoad = createAsyncThunk(
    "admin/idNoteLoad", async(id, thunkApi) => {
        const {dispatch} = thunkApi;
        const url = serverPath + "/api/notes/";
        const urlToFetch = `${url}${id}`;
        const response = await fetch(urlToFetch, {
            method: 'GET',
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Authorization": `Bearer ${localStorage.getItem('token')}`,
            },
           
            credentials: 'include',
            mode: 'cors',
        });
        console.log(response);
        let dataNoteIdContent = [];
        if (response.ok) {
            const jsonResponse = await response.json();
            dataNoteIdContent = jsonResponse;
            console.log(jsonResponse);
            return dataNoteIdContent;

            //REFRESH ACCESS TOKEN IF 401

        } else if (response.status === 401) {
          
            console.log('401 -refresh access token!');
            try {
                const result = await dispatch(refreshAccessToken());
              //IF ACCESS AND REFRESH TOKEN BAD
                console.log(result.payload);
                if (result.payload) {
                   // console.log('GOOD ACCESS!!!!');
                  dispatch(idNoteLoad(id));
                } else {
                    console.log('Bad refresh access');
                }
            } catch (e) {
                console.log('Error');
            };



        } else {
           
           console.log('BAD GET note');
         return response.status;
         }
        
    }
);
/*
//GET PDF FILE- no use -get pdf file by name 
export const pdfLoad = createAsyncThunk(
    "admin/pdfLoad", async(item, thunkApi) => {
        const {dispatch} = thunkApi;
        const url = serverPath + "/api/pdf/";
        const urlToFetch = `${url}${item.noteId}/${item.pdfName}`;
        const response = await fetch(urlToFetch, {
            method: 'GET',
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Authorization": `Bearer ${localStorage.getItem('token')}`,
            },
           
            credentials: 'include',
            mode: 'cors',
        });
        console.log(response);
        let dataNoteIdContent = [];
        if (response.ok) {
            const jsonResponse = await response.json();
            dataNoteIdContent = jsonResponse;
            console.log(jsonResponse);
            return dataNoteIdContent;

            //REFRESH ACCESS TOKEN IF 401

        } else if (response.status === 401) {
          
            console.log('401 -refresh access token!');
            try {
                const result = await dispatch(refreshAccessToken());
              //IF ACCESS AND REFRESH TOKEN BAD
                console.log(result.payload);
                if (result.payload) {
                   // console.log('GOOD ACCESS!!!!');
                  dispatch(pdfLoad(item));
                } else {
                    console.log('Bad refresh access');
                }
            } catch (e) {
                console.log('Error');
            };



        } else {
           
           console.log('BAD GET pdf');
         return response.status;
         }
        
    }
);
*/
//GET ID NOTE ADD FILES
export const idNoteAddFilesLoad = createAsyncThunk(
    "admin/idNoteAddFilesLoad", async(id, thunkApi) => {
        const {dispatch} = thunkApi;
        const url = serverPath + "/api/getaddnotefiles/";
        const urlToFetch = `${url}${id}`;
        const response = await fetch(urlToFetch, {
            method: 'GET',
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Authorization": `Bearer ${localStorage.getItem('token')}`,
            },
           
            credentials: 'include',
            mode: 'cors',
        });
        console.log(response);
        let dataNoteAddFilesIdContent = [];
        if (response.ok) {
            const jsonResponse = await response.json();
            dataNoteAddFilesIdContent = jsonResponse;
            console.log(jsonResponse);
            return dataNoteAddFilesIdContent;

            //REFRESH ACCESS TOKEN IF 401

        } else if (response.status === 401) {
          
            console.log('401 -refresh access token!');
            try {
                const result = await dispatch(refreshAccessToken());
              //IF ACCESS AND REFRESH TOKEN BAD
                console.log(result.payload);
                if (result.payload) {
                   // console.log('GOOD ACCESS!!!!');
                  dispatch(idNoteAddFilesLoad(id));
                } else {
                    console.log('Bad refresh access');
                }
            } catch (e) {
                console.log('Error');
            };



        } else {
           
           console.log('BAD GET note add files');
         return response.status;
         }
        
    }
);
//DELETE IMAGE NOTE PART-no use
export const noteImagePartDelete = createAsyncThunk(
    "admin/noteImagePartDelete", async(item, thunkApi) => {
        console.log(item);
        const {dispatch} = thunkApi;
        const url = serverPath + "/api/deleteimagenotes/";
        const urlToFetch = `${url}${item.note_id}/${item.img_path}`;
        const response = await fetch(urlToFetch, {
            method: 'DELETE',
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Authorization": `Bearer ${localStorage.getItem('token')}`
            },
            body: JSON.stringify({
                note_id: item.note_id,
                img_path: item.img_path
                //main_name: item.main_name
                               
            })
        });
        
         if (response.ok) {
            const answer = await response.json();
           
            console.log('Успех:', JSON.stringify(answer));
            console.log(answer);
           return answer;
         //REFRESH ACCESS TOKEN IF 401

         } else if (response.status === 401) {
          
            console.log('401 -refresh access token!');
            try {
                const result = await dispatch(refreshAccessToken());
              //IF ACCESS AND REFRESH TOKEN BAD
                console.log(result.payload);
                if (result.payload) {
                   // console.log('GOOD ACCESS!!!!');
                  dispatch(noteImagePartDelete(item));
                } else {
                    console.log('Bad refresh access');
                }
            } catch (e) {
                console.log('Error');
            };
        
        
        } else {console.log(response);}

    }
);

//DELETE  NOTE PART
export const notePartDelete = createAsyncThunk(
    "admin/notePartDelete", async(item, thunkApi) => {
        console.log(item);
        const {dispatch} = thunkApi;
        const url = serverPath + "/api/deletenotes/";
        const urlToFetch = `${url}${item.note_id}/${item.note_part}`;
        const response = await fetch(urlToFetch, {
            method: 'DELETE',
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Authorization": `Bearer ${localStorage.getItem('token')}`
            },
            body: JSON.stringify({
                note_id: item.note_id,
                note_part: item.note_part
              
                               
            })
        });
        
         if (response.ok) {
            const answer = await response.json();
           
            console.log('Успех:', JSON.stringify(answer));
            console.log(answer);
           return answer;
            //REFRESH ACCESS TOKEN IF 401

          } else if (response.status === 401) {
          
            console.log('401 -refresh access token!');
            try {
                const result = await dispatch(refreshAccessToken());
              //IF ACCESS AND REFRESH TOKEN BAD
                console.log(result.payload);
                if (result.payload) {
                   // console.log('GOOD ACCESS!!!!');
                  dispatch(notePartDelete(item));
                } else {
                    console.log('Bad refresh access');
                }
            } catch (e) {
                console.log('Error');
            };
        } else {console.log(response);}

    }
);
//DELETE  ADDFILE
export const addFileDelete = createAsyncThunk(
    "admin/addFileDelete", async(item, thunkApi) => {
        console.log(item);
        const {dispatch} = thunkApi;
        const url = serverPath + "/api/deleteaddfile/";
        const urlToFetch = `${url}${item.noteId}/${item.id}`;
        const response = await fetch(urlToFetch, {
            method: 'DELETE',
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Authorization": `Bearer ${localStorage.getItem('token')}`
            },
            body: JSON.stringify({
                noteId: item.noteId,
                id: item.id
              
                               
            })
        });
        
         if (response.ok) {
            const answer = await response.json();
           
            console.log('Успех:', JSON.stringify(answer));
            console.log(answer);
           return answer;
            //REFRESH ACCESS TOKEN IF 401

          } else if (response.status === 401) {
          
            console.log('401 -refresh access token!');
            try {
                const result = await dispatch(refreshAccessToken());
              //IF ACCESS AND REFRESH TOKEN BAD
                console.log(result.payload);
                if (result.payload) {
                   // console.log('GOOD ACCESS!!!!');
                  dispatch(addFileDelete(item));
                } else {
                    console.log('Bad refresh access');
                }
            } catch (e) {
                console.log('Error');
            };
        } else {console.log(response);}

    }
);
//EDIT NOTE PART

export const editNotePart = createAsyncThunk(
    "auth/editNotePart", async(item, thunkApi) => {
       console.log(item);
       const {dispatch} = thunkApi;
        const url = serverPath + "/api/editnotes/";
        const urlToFetch = `${url}`;
        const response = await fetch(urlToFetch, {
            method: 'POST',
          headers: {
           // "Content-Type": "multipart/form-data  ",
            "Authorization": `Bearer ${localStorage.getItem('token')}`,
          },
          
            body: item,
            credentials: 'include',
            mode: 'cors',
        });
        
        if (response.ok) {
            const answer = await response.json();
          //  console.log('Успех Edit Note part:', JSON.stringify(answer));
          // console.log(answer);
           
            return answer;
        } 
        //REFRESH ACCESS TOKEN IF 401

         else if (response.status === 401) {
          
        console.log('401 -refresh access token!');
        try {
            const result = await dispatch(refreshAccessToken());
          //IF ACCESS AND REFRESH TOKEN BAD
            console.log(result.payload);
            if (result.payload) {
               // console.log('GOOD ACCESS!!!!');
              dispatch(editNotePart(item));
            } else {
                console.log('Bad refresh access');
            }
        } catch (e) {
            console.log('Error');
        };
        
        
        
        } else {
    
          // const answer = await response.json();
            //console.log(answer.message);
    
           // console.log(response);
           console.log('BAD EDIT NOTE ');
            return response.status;
           // console.log(response.status);
           // console.log(response)
        }
    
    
    }
    );
//CREATE ID TROUBLE
export const idTroubleCreate = createAsyncThunk( 
        "admin/idTroubleCreate", async(item, thunkApi) => {
            const {dispatch} = thunkApi;
            console.log(item);
            const url = serverPath + "/api/troubles/";
            const urlToFetch = `${url}`;
            const response = await fetch(urlToFetch, {
                method: 'POST',
                headers: {
                    "Content-Type": "application/json; charset=utf-8",
                    "Authorization": `Bearer ${localStorage.getItem('token')}`,},
                body: JSON.stringify({
                    noteId: item.noteId,
                    notePart: item.notePart,
                    textTrouble: item.textTrouble,
                    userId: item.userId,
                    imgPath: item.imgPath
                })
            });
            
             if (response.ok) {
                const answer = await response.json();
               
                console.log('Успех:', JSON.stringify(answer));
                console.log(answer);
               return answer;
            } else if (response.status === 401) {
              
                console.log('401 -refresh access token!');
                try {
                    const result = await dispatch(refreshAccessToken());
                  //IF ACCESS AND REFRESH TOKEN BAD
                    console.log(result.payload);
                    if (result.payload) {
                      dispatch(idTroubleCreate(item));
                    } else {
                        console.log('Bad refresh access');
                    }
                } catch (e) {
                    console.log('Error');
                }
            } else {console.log(response);}
    
        }
    );
    //CREATE ANSWER   ON TROUBLE
export const idAnswerOnTroubleCreate = createAsyncThunk( 
    "admin/idAnswerOnTroubleCreate", async(item, thunkApi) => {
        const {dispatch} = thunkApi;
        console.log(item);
        const url = serverPath + "/api/troubles/answer";
        const urlToFetch = `${url}`;
        const response = await fetch(urlToFetch, {
            method: 'POST',
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Authorization": `Bearer ${localStorage.getItem('token')}`,},
            body: JSON.stringify({
                troubleId: item.troubleId,
                textAnswer: item.textAnswer,
                userId: item.userId,
                imgPath: item.imgPath
            })
        });
        
         if (response.ok) {
            const answer = await response.json();
           
            console.log('Успех:', JSON.stringify(answer));
            console.log(answer);
           return answer;
        } else if (response.status === 401) {
          
            console.log('401 -refresh access token!');
            try {
                const result = await dispatch(refreshAccessToken());
              //IF ACCESS AND REFRESH TOKEN BAD
                console.log(result.payload);
                if (result.payload) {
                  dispatch(idAnswerOnTroubleCreate(item));
                } else {
                    console.log('Bad refresh access');
                }
            } catch (e) {
                console.log('Error');
            }
        } else {console.log(response);}

    }
);
//DELETE  ANSWER   ON TROUBLE
export const answerTroubleDelete = createAsyncThunk(
    "admin/answerTroubleDelete", async(item, thunkApi) => {
        console.log(item);
        const {dispatch} = thunkApi;
        const url = serverPath + "/api/deleteanswer/";
        const urlToFetch = `${url}/${item.id}`;
        const response = await fetch(urlToFetch, {
            method: 'DELETE',
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Authorization": `Bearer ${localStorage.getItem('token')}`
            },
            body: JSON.stringify({
                
                id: item.id
              
                               
            })
        });
        
         if (response.ok) {
            const answer = await response.json();
           
            console.log('Успех:', JSON.stringify(answer));
            console.log(answer);
           return answer;
            //REFRESH ACCESS TOKEN IF 401

          } else if (response.status === 401) {
          
            console.log('401 -refresh access token!');
            try {
                const result = await dispatch(refreshAccessToken());
              //IF ACCESS AND REFRESH TOKEN BAD
                console.log(result.payload);
                if (result.payload) {
                   // console.log('GOOD ACCESS!!!!');
                  dispatch(answerTroubleDelete(item));
                } else {
                    console.log('Bad refresh access');
                }
            } catch (e) {
                console.log('Error');
            };
        } else {console.log(response);}

    }
);
//DELETE   TROUBLE
export const troubleDelete = createAsyncThunk(
    "admin/troubleDelete", async(item, thunkApi) => {
        console.log(item);
        const {dispatch} = thunkApi;
        const url = serverPath + "/api/deletetrouble/";
        const urlToFetch = `${url}/${item.id}`;
        const response = await fetch(urlToFetch, {
            method: 'DELETE',
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Authorization": `Bearer ${localStorage.getItem('token')}`
            },
            body: JSON.stringify({
                
                id: item.id
              
                               
            })
        });
        
         if (response.ok) {
            const answer = await response.json();
           
            console.log('Успех:', JSON.stringify(answer));
            console.log(answer);
           return answer;
            //REFRESH ACCESS TOKEN IF 401

          } else if (response.status === 401) {
          
            console.log('401 -refresh access token!');
            try {
                const result = await dispatch(refreshAccessToken());
              //IF ACCESS AND REFRESH TOKEN BAD
                console.log(result.payload);
                if (result.payload) {
                   // console.log('GOOD ACCESS!!!!');
                  dispatch(troubleDelete(item));
                } else {
                    console.log('Bad refresh access');
                }
            } catch (e) {
                console.log('Error');
            };
        } else {console.log(response);}

    }
);
    //ADD ANSWER  RATE  ON TROUBLE
export const addAnswerRateOnTrouble = createAsyncThunk( 
    "admin/addAnswerRateOnTrouble ", async(item, thunkApi) => {
        const {dispatch} = thunkApi;
        console.log(item);
        const url = serverPath + "/api/troubles/rate";
        const urlToFetch = `${url}`;
        const response = await fetch(urlToFetch, {
            method: 'POST',
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Authorization": `Bearer ${localStorage.getItem('token')}`,},
            body: JSON.stringify({
               answerId: item.answerId,
               valueRate: item.valueRate,
            })
        });
        
         if (response.ok) {
            const answer = await response.json();
           
            console.log('Успех:', JSON.stringify(answer));
            console.log(answer);
           return answer;
        } else if (response.status === 401) {
          
            console.log('401 -refresh access token!');
            try {
                const result = await dispatch(refreshAccessToken());
              //IF ACCESS AND REFRESH TOKEN BAD
                console.log(result.payload);
                if (result.payload) {
                  dispatch(addAnswerRateOnTrouble(item));
                } else {
                    console.log('Bad refresh access');
                }
            } catch (e) {
                console.log('Error');
            }
        } else {console.log(response);}

    }
);
    //SET PUBLIC PRIVATE ON SUBCATEGORY
export const setPublicOptionSubCategory = createAsyncThunk( 
    "admin/setPublicOptionSubCategory ", async(item, thunkApi) => {
        const {dispatch} = thunkApi;
        console.log(item);
        const url = serverPath + "/api/subcategoryoption/";
        const urlToFetch = `${url}`;
        const response = await fetch(urlToFetch, {
            method: 'PUT',
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Authorization": `Bearer ${localStorage.getItem('token')}`,},
            body: JSON.stringify({
               subId: item.subId,
               publicOption: item.publicOption,
            })
        });
        
         if (response.ok) {
            const answer = await response.json();
           
            console.log('Успех:', JSON.stringify(answer));
            console.log(answer);
           return answer[0];
        } else if (response.status === 401) {
          
            console.log('401 -refresh access token!');
            try {
                const result = await dispatch(refreshAccessToken());
              //IF ACCESS AND REFRESH TOKEN BAD
                console.log(result.payload);
                if (result.payload) {
                  dispatch(setPublicOptionSubCategory(item));
                } else {
                    console.log('Bad refresh access');
                }
            } catch (e) {
                console.log('Error');
            }
        } else {console.log(response);}

    }
);
    //SET PUBLIC PRIVATE ON QUIZ
export const setPublicOptionQuiz = createAsyncThunk( 
    "admin/setPublicOptionQuiz ", async(item, thunkApi) => {
        const {dispatch} = thunkApi;
        console.log(item);
        const url = serverPath + "/api/quizesoption/";
        const urlToFetch = `${url}`;
        const response = await fetch(urlToFetch, {
            method: 'PUT',
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Authorization": `Bearer ${localStorage.getItem('token')}`,},
            body: JSON.stringify({
               quizId: item.quizId,
               publicOption: item.publicOption,
            })
        });
        
         if (response.ok) {
            const answer = await response.json();
           
            console.log('Успех:', JSON.stringify(answer));
            console.log(answer);
           return answer[0];
        } else if (response.status === 401) {
          
            console.log('401 -refresh access token!');
            try {
                const result = await dispatch(refreshAccessToken());
              //IF ACCESS AND REFRESH TOKEN BAD
                console.log(result.payload);
                if (result.payload) {
                  dispatch(setPublicOptionQuiz(item));
                } else {
                    console.log('Bad refresh access');
                }
            } catch (e) {
                console.log('Error');
            }
        } else {console.log(response);}

    }
);

const initialStateForAdmin = {
         
            adminView: false,
            dataQuizes: [],
            isFetching: true,
            error: null,
            dataCategories:[],
            dataSubCategoryId:[],
            dataQuizesId: [],
            dataQuestionsId: [],
            dataAnswersId: [],
            dataAnswersIdForType2: [],
            dataAnswersIdForType3: [],
            dataAnswersIdForType4: [],
    
            openInputForms: false, //FOR ANSWERS
            openInputFormsForAnswersType2: false,
             openInputFormsForAnswersType3: false,
            openInputFormsForAnswersType4: false,
            openInputFormsForQuestions: false, //FOR QUESTIONS
            openInputFormsForQuizes: false, //FOR QUIZES
            openInputFormsForSubCategories: false, //FOR SUBCATEGORIES
            openInputFormsForCategories: false, //FOR CATEGORIES
    
            openAddInputFormsForCategories: false, //FOR ADD CATEGORIES
            openAddInputFormsForSubCategories: false, //FOR ADD SUBCATEGORIES
            openAddInputFormsForQuizes: false, //FOR ADD QUIZES 
            openAddInputFormsForQuestions: false, //FOR ADD QUESTIONS
            openAddInputFormsForAnswers: false, //FOR ADD ANSWERS
            openAddInputFormsForAnswersType2: false, //FOR ADD ANSWERS
            openAddInputFormsForAnswersType3: false, //FOR ADD ANSWERS
            openAddInputFormsForAnswersType4: false, //FOR ADD ANSWERS
    
            openDeleteInputForms: false, //FOR CATEGORIES
            openDeleteInputFormsForSubCategories: false, //FOR SUBCATEGORIES
            openDeleteInputFormsForQuizes: false, //FOR QUIZES
            openDeleteInputFormsForQuestions: false, //FOR QUESTION
            openDeleteInputFormsForAnswers: false, //FOR QUESTION 
            openDeleteInputFormsForQuestionsImg: false, //FOR QUESTION IMG

            openPreviewQuestionImgForms: false,
    
            //NOTES
            openDeleteInputFormsForImageNotePart:false,
            openDeleteInputFormsForNotePart:false,
            openInputFormsForNote: false,
            selectedIdNote: null,
            selectedIdNoteText:null,
            selectedPartNote:null,
            selectedDeletedImgPath:null,
            adminNoteViewActive: false,
            adminEditNoteViewActive: false,
            
    
            openAdminQuizesView: false,
            errorNoteImageValidateType: '',
            errorNoteImageValidateSize: '',
            adminPdfViewer: false,
            dataNotes:[
            {
                id:0,
               // title:"Название заметки",
                content: [
                            {part:1,text:"a",img_path:"b",img_text:"c", title:''},
                            {part:2,text:"a",img_path:"b",img_text:"c", title:''},
                            {part:3,text:"a",img_path:"b",img_text:"c", title:''}
                        ]
            },
            
        
        
        
        ],
        dataTroubles:[
           ],
        dataAnswerTroubles:[],
        selectedIdAnswerTrouble:'',
        selectedIdTrouble:'',
    
            dataAnswersId_1: [],
            selectedId: null,
            selectedCategory: null,
            selectedSubCategory: null,
            selectedQuize: null,
            selectedQuestion: null,
                      //SORT QUESTIONS
            sortQuestion: null,
            selectedImgName:'',
            selectedQuestionContent:'',
    //FOR ADDFILES 
            noteAddFiles: [],
            openDeleteInputFormsForAddFile: false,
            selectedIdAddFile:'', 
            errorAddFileValidateType: '',
            errorAddFileValidateSize: '',
            //FOR TASKS
            adminDataTaskView: false, 
                    //FOR QUESTIONS OF QUIZ
            errorQuizImageValidateType:'',
            errorQuizImageValidateSize:'', 
        };

const options = {
    name: 'admin',
    initialState: {

        adminView: false,
        dataQuizes: [],
        isFetching: true,
        error: null,
        dataCategories:[],
        dataSubCategoryId:[],
        dataQuizesId: [],
        dataQuestionsId: [],
        // FOR TYPES QUESTIONS
        dataAnswersId: [],
        dataAnswersIdForType2: [],
        dataAnswersIdForType3: [],
        dataAnswersIdForType4: [],

        openInputForms: false, //FOR ANSWERS
        openInputFormsForAnswersType2: false,
        openInputFormsForAnswersType3: false,
        openInputFormsForAnswersType4: false,
        openInputFormsForQuestions: false, //FOR QUESTIONS
        openInputFormsForQuizes: false, //FOR QUIZES
        openInputFormsForSubCategories: false, //FOR SUBCATEGORIES
        openInputFormsForCategories: false, //FOR CATEGORIES

        openAddInputFormsForCategories: false, //FOR ADD CATEGORIES
        openAddInputFormsForSubCategories: false, //FOR ADD SUBCATEGORIES
        openAddInputFormsForQuizes: false, //FOR ADD QUIZES 
        openAddInputFormsForQuestions: false, //FOR ADD QUESTIONS
        openAddInputFormsForAnswers: false, //FOR ADD ANSWERS
        openAddInputFormsForAnswersType2: false, //FOR ADD ANSWERS
        openAddInputFormsForAnswersType3: false, //FOR ADD ANSWERS
        openAddInputFormsForAnswersType4: false, //FOR ADD ANSWERS

        openDeleteInputForms: false, //FOR CATEGORIES
        openDeleteInputFormsForSubCategories: false, //FOR SUBCATEGORIES
        openDeleteInputFormsForQuizes: false, //FOR QUIZES
        openDeleteInputFormsForQuestions: false, //FOR QUESTION
        openDeleteInputFormsForAnswers: false, //FOR QUESTION
        openDeleteInputFormsForQuestionsImg: false, //FOR QUESTION IMG  

        openPreviewQuestionImgForms: false,

        //NOTES
        openDeleteInputFormsForImageNotePart:false,
        openDeleteInputFormsForNotePart:false,
        openInputFormsForNote: false,
        selectedIdNote: null,
        selectedIdNoteText:null,
        selectedPartNote:null,
        selectedDeletedImgPath:null,
        adminNoteViewActive: false,
        adminEditNoteViewActive: false,
        

        openAdminQuizesView: false,
        errorNoteImageValidateType: '',
        errorNoteImageValidateSize: '',
        adminFoldererView: false,
        adminPdfViewer: false,
        pdfName:'',
        dataNotes:[
        {
            id:0,
           // title:"Название заметки",
            content: [
                        {part:1,text:"a",img_path:"b",img_text:"c", title:''},
                        {part:2,text:"a",img_path:"b",img_text:"c", title:''},
                        {part:3,text:"a",img_path:"b",img_text:"c", title:''}
                    ]
        },
        
    
    
    
            ],
            //TROUBLES
        dataTroubles:[],
        dataAnswerTroubles:[],
        selectedIdAnswerTrouble:'',
        selectedIdTrouble:'',

        dataAnswersId_1: [],
        selectedId: null,
        selectedCategory: null,
        selectedSubCategory: null,
        selectedQuize: null,
        selectedQuestion: null,
                              //SORT QUESTIONS
        sortQuestion: null,
        selectedImgName:'',
        selectedQuestionContent:'',

         //FOR ADDFILES
        noteAddFiles: [],
        openDeleteInputFormsForAddFile: false,
        selectedIdAddFile:'',
        errorAddFileValidateType: '',
        errorAddFileValidateSize: '', 
         //FOR TASKS
        adminDataTaskView: false, 
        //FOR QUESTIONS OF QUIZ
        errorQuizImageValidateType:'',
        errorQuizImageValidateSize:'', 
    },
    reducers: {
        // GET first INITIAL STATE for admin
         getInitialStateForAdmin: state  => 
                 initialStateForAdmin,

        openAdminView: (state) => {
            state.adminView = true;
        },
        closeAdminView: (state) => {
            state.adminView = false;
        },
        openInputForms: (state, action) => {
            state.openInputForms = true;
           // console.log(action.payload);
            state.selectedId = action.payload;
        },
        openInputFormsForAnswersType2: (state, action) => {
            state.openInputFormsForAnswersType2 = true;
           // console.log(action.payload);
            state.selectedId = action.payload;
        },
        openInputFormsForAnswersType3: (state, action) => {
            state.openInputFormsForAnswersType3 = true;
           // console.log(action.payload);
            state.selectedId = action.payload;
        },
        openInputFormsForAnswersType4: (state, action) => {
            state.openInputFormsForAnswersType4 = true;
           // console.log(action.payload);
            state.selectedId = action.payload;
        },
        openPreviewQuestionImgForms: (state, action) => {
            state.openPreviewQuestionImgForms = true;
            console.log(action.payload);
            state.selectedId = action.payload.id;
            state.selectedImgName = action.payload.imgName;
            state.selectedQuestionContent = action.payload.questionContent;
        },
        closePreviewQuestionImgForms: (state, action) => {
            state.openPreviewQuestionImgForms = false;
           // console.log(action.payload);
            
        },
        //NOTES
        addDeletedImgPathPartNote: (state, action) =>{
            state.selectedDeletedImgPath = action.payload;
        },
        openDeleteInputFormsForImageNotePart: (state) => {
            state.openDeleteInputFormsForImageNotePart = !state.openDeleteInputFormsForImageNotePart;
        },
        openDeleteInputFormsForNotePart: (state) => {
            state.openDeleteInputFormsForNotePart = !state.openDeleteInputFormsForNotePart;
        },
        addSelectedPartNote: (state, action) =>{
            state.selectedPartNote = action.payload;
        },
        openInputFormsForNote: (state, action) => {
            state.openInputFormsForNote = true;
            console.log(action.payload);
           //selected Id quize === selected id note
            state.selectedIdNote = action.payload.id;
            state.selectedIdNoteText = action.payload.nameQuiz;
        },
        closeInputFormsForNote: (state, action) => {
            state.openInputFormsForNote = false;
          
        },
        activateAdminNoteView: (state, action) => {
            state.adminNoteViewActive = true;
            state.adminEditNoteViewActive = false;
        },
        closeAdminNoteView: (state, action) => {
            state.adminNoteViewActive = false;
            state.adminEditNoteViewActive = false;
        },
        activateEditAdminNoteView: (state, action) => {
            state.adminEditNoteViewActive = true;
            state.adminNoteViewActive = true;
        },
        validateNoteImageType: (state, action) => {
            if (!action.payload) {
                state.errorNoteImageValidateType ='Неправильный формат изображения. Допустимые форматы -jpg, jpeg, gif, png, webp.';
            } else {
                state.errorNoteImageValidateType = '';
            }
           
        },
        validateNoteImageSize: (state, action) => {
            if (!action.payload) {
                state.errorNoteImageValidateSize = 'Слишком большой файл. Допустимый размер файла 1.0Мб';
            } else {
                state.errorNoteImageValidateSize = '';
            }
           
        },
        validateAddFileType: (state, action) => {
            if (!action.payload) {
                state.errorAddFileValidateType ='Неправильный формат изображения. Допустимые форматы -pdf, lir, spf, spr, opr.';
            } else {
                state.errorAddFileValidateType = '';
            }
           
        },
        validateAddFileSize: (state, action) => {
            if (!action.payload) {
                state.errorAddFileValidateSize = 'Слишком большой файл. Допустимый размер файла 10.0Мб';
            } else {
                state.errorAddFileValidateSize = '';
            }
           
        },
                clearErrorsValidateAddFile: (state, action) => {
         
                state.errorAddFileValidateSize = '';
                state.errorAddFileValidateType = '';
           
           
        },

        openQuizesAdminView: (state, action) => {
            state.openAdminQuizesView = true;
        },
        openInputFormsForQuestions: (state, action) => {
            state.openInputFormsForQuestions = true;
           // console.log(action.payload);
            state.selectedId = action.payload.id;
            state.selectedImgName = action.payload.imgName;
        },
        openInputFormsForQuizes: (state, action) => {
            state.openInputFormsForQuizes = true;
           // console.log(action.payload);
            state.selectedId = action.payload;
        },
        openInputFormsForSubCategories: (state, action) => {
            state.openInputFormsForSubCategories = true;
           // console.log(action.payload);
            state.selectedId = action.payload;
        },
        openInputFormsForCategories: (state, action) => {
            state.openInputFormsForCategories = true;
           // console.log(action.payload);
            state.selectedId = action.payload;
        },
        openAddInputFormsForCategories: (state, action) => {
            state.openAddInputFormsForCategories = true;
           // console.log(action.payload);
           
        },
        openAddInputFormsForSubCategories: (state, action) => {
            state.openAddInputFormsForSubCategories = true;
           // console.log(action.payload);
           
        },
        openAddInputFormsForQuizes: (state, action) => {
            state.openAddInputFormsForQuizes = true;
           // console.log(action.payload);
           
        },
        openAddInputFormsForQuestions: (state, action) => {
            state.openAddInputFormsForQuestions = true;
           // console.log(action.payload);
           
        },
        openAddInputFormsForAnswers: (state, action) => {
            state.openAddInputFormsForAnswers = true;
           // console.log(action.payload);
           
        }, 
        openAddInputFormsForAnswersType2: (state, action) => {
            state.openAddInputFormsForAnswersType2 = true;
           // console.log(action.payload);
           
        },
        openAddInputFormsForAnswersType3: (state, action) => {
            state.openAddInputFormsForAnswersType3 = true;
           // console.log(action.payload);
           
        },
        openAddInputFormsForAnswersType4: (state, action) => {
            state.openAddInputFormsForAnswersType4 = true;
           // console.log(action.payload);
           
        },        
        openDeleteInputForms: (state, action) => {
            state.openDeleteInputForms = true;
           // console.log(action.payload);
           state.selectedId = action.payload;
           
        },
        openDeleteInputFormsForSubCategories: (state, action) => {
            state.openDeleteInputFormsForSubCategories = true;
           // console.log(action.payload);
           state.selectedId = action.payload;
           
        },
        openDeleteInputFormsForQuizes: (state, action) => {
            state.openDeleteInputFormsForQuizes = true;
           // console.log(action.payload);
           state.selectedId = action.payload;
           
        },
        openDeleteInputFormsForQuestions: (state, action) => {
            state.openDeleteInputFormsForQuestions = true;
           // console.log(action.payload);
           state.selectedId = action.payload;
           
        },
        openDeleteInputFormsForQuestionsImg: (state, action) => {
            state.openDeleteInputFormsForQuestionsImg = true;
           // console.log(action.payload);
           state.openInputFormsForQuestions = false;
           
        },
        closeDeleteInputFormsForQuestionsImg: (state, action) => {
            state.openDeleteInputFormsForQuestionsImg = false;
           // console.log(action.payload);
           state.openInputFormsForQuestions = true;
           
        },  
        openDeleteInputFormsForAnswers: (state, action) => {
            state.openDeleteInputFormsForAnswers = true;
           // console.log(action.payload);
           state.selectedId = action.payload;
           
        }, 
        openDeleteInputFormsForAddFile: (state, action) => {
            state.openDeleteInputFormsForAddFile = true;
           // console.log(action.payload);
           state.selectedIdAddFile = action.payload;
           
        },
        closeDeleteInputFormsForAddFile: (state, action) => {
            state.openDeleteInputFormsForAddFile = false;
                  
           
        },             
        closeInputForms: (state, action) => {
            state.openInputForms = false;
            state.openInputFormsForAnswersType2 = false;
            state.openInputFormsForAnswersType3 = false;
            state.openInputFormsForAnswersType4 = false;
            state.openInputFormsForQuestions = false;
            state.openInputFormsForQuizes = false;
            state.openInputFormsForSubCategories = false;
            state.openInputFormsForCategories = false;
            state.openAddInputFormsForCategories = false;
            state.openDeleteInputForms = false;
            state.openAddInputFormsForSubCategories = false;
            state.openDeleteInputFormsForSubCategories = false;
            state.openAddInputFormsForQuizes = false;
            state.openDeleteInputFormsForQuizes = false;
            state.openAddInputFormsForQuestions = false;
            state.openDeleteInputFormsForQuestions = false;
            state.openAddInputFormsForAnswers = false;
            state.openDeleteInputFormsForAnswers = false;
            state.openInputFormsForNote = false;
            state.openDeleteInputFormsForAddFile = false;
            state.openAddInputFormsForAnswersType2 = false;
            state.openAddInputFormsForAnswersType3 = false;
            state.openAddInputFormsForAnswersType4 = false;
            
            
        },
        getIdSelectedCategory: (state, action) => {
            state.selectedCategory = action.payload;
        },
        getIdSelectedSubCategory: (state, action) => {
            state.selectedSubCategory = action.payload;
        },
        getIdSelectedQuize: (state, action) => {
            state.selectedQuize = action.payload;
            
        },
        getIdSelectedQuestion: (state, action) => {
            state.selectedQuestion = action.payload.id;
            state.sortQuestion = action.payload.sortQuestion;
        },
        setInitialStateQuestions: (state) => {
            
            state.sortQuestion = null;
        },
         closeAdminFoldererView: (state, action) => {
        state.adminFoldererView= false;
         },
         changeAdminFoldererView: (state, action) => {
        state.adminFoldererView= !state.adminFoldererView;
    },
        changeAdminPdfView: (state, action) => {
            state.adminPdfViewer= !state.adminPdfViewer;
        },
        closeAdminPdfView: (state, action) => {
        state.adminPdfViewer= false;
         },
         setPdfFileName: (state, action) => {
            state.pdfName = action.payload;
         },
        setSelectedIdAnswerTrouble: (state, action) => {
            state.selectedIdAnswerTrouble = action.payload;
         },
        setSelectedIdTrouble: (state, action) => {
            state.selectedIdTrouble = action.payload;
         },
        setAdminDataTaskView: (state) => {
            state.adminDataTaskView = !state.adminDataTaskView;
         },
        closeAdminDataTaskView: (state) => {
            state.adminDataTaskView = false;
         },
      validateQuizImageType: (state, action) => {
            if (!action.payload) {
                state.errorQuizImageValidateType ='Неправильный формат изображения. Допустимые форматы -jpg, jpeg, gif, png, webp.';
            } else {
                state.errorQuizImageValidateType = '';
            }
           
        },
        validateQuizImageSize: (state, action) => {
            if (!action.payload) {
                state.errorQuizImageValidateSize = 'Слишком большой файл. Допустимый размер файла 1.0Мб';
            } else {
                state.errorQuizImageValidateSize = '';
            }
           
        },
    },
    extraReducers(builder) {
        builder
        //GET ALL QUIZES
        .addCase(allQizesLoad.pending, (state, action) => {
            state.isFetching = true;
            state.error = false;
        })
        .addCase(allQizesLoad.fulfilled, (state, action) => {
            if (action.payload) {
            state.dataQuizes = action.payload;
            }
            state.isFetching = true;
            state.error= false;
        })
        .addCase(allQizesLoad.rejected, (state, action) => {
            state.isFetching = false;
            state.error = action.payload;
            console.log("oh wrong!!!");
        })
        //GET ALL CATEGORIES
        .addCase(allCategoriesLoad.pending, (state, action) => {
            state.isFetching = true;
            state.error = false;
        })
        .addCase(allCategoriesLoad.fulfilled, (state, action) => {
            if (action.payload) {
            state.dataCategories = action.payload;
            }
            state.isFetching = true;
            state.error= false;
        })
        .addCase(allCategoriesLoad.rejected, (state, action) => {
            state.isFetching = false;
            state.error = action.payload;
            console.log("oh wrong!!!");
        })
        //
        //GET ID SUBCATEGORIES
        .addCase(idSubCategoryLoad.pending, (state, action) => {
            state.isFetching = true;
            state.error = false;
        })
        .addCase(idSubCategoryLoad.fulfilled, (state, action) => {
            if (action.payload) {
            state.dataSubCategoryId = action.payload;
            }
            state.isFetching = true;
            state.error= false;
            state.dataQuizesId = [];
            state.dataAnswersId = [];
            state.dataQuestionsId = [];
            state.selectedQuize = null;
            state.selectedQuestion = null;
            state.selectedSubCategory = null;
        })
        .addCase(idSubCategoryLoad.rejected, (state, action) => {
            state.isFetching = false;
            state.error = action.payload;
            console.log("oh wrong!!!");
        })
         //GET ID QUIZES
         .addCase(idQuizLoad.pending, (state, action) => {
            state.isFetching = true;
            state.error = false;
        })
        .addCase(idQuizLoad.fulfilled, (state, action) => {
            if (action.payload) {
            state.dataQuizesId = action.payload;
            }
            state.isFetching = true;
            state.error= false;
            state.dataQuestionsId = [];
            state.dataAnswersId = [];
            state.selectedQuize = null;
            state.selectedQuestion = null;
        })
        .addCase(idQuizLoad.rejected, (state, action) => {
            state.isFetching = false;
            state.error = action.payload;
            console.log("oh wrong!!!");
        })
            //GET ID QUESTIONS
        .addCase(idQuestionsLoad.pending, (state, action) => {
            state.isFetching = true;
            state.error = false;
        })
        .addCase(idQuestionsLoad.fulfilled, (state, action) => {
            if (action.payload) {
            state.dataQuestionsId = action.payload;
            }
            state.isFetching = true;
            state.error= false;
            state.dataAnswersId = [];
            state.selectedQuestion = null;
        })
        .addCase(idQuestionsLoad.rejected, (state, action) => {
            state.isFetching = false;
            if (action.payload) {
            state.error = action.payload;
            }
            console.log("oh wrong!!!");
        })
        //GET ID ANSWERS
        .addCase(idAnswersLoad.pending, (state, action) => {
            state.isFetching = true;
            state.error = false;
        })
        .addCase(idAnswersLoad.fulfilled, (state, action) => {
           if (action.payload) {

                if ((Number(action.payload.sortQuestion)) === 1) {
                state.dataAnswersId = action.payload.answer;
                }
                if ((Number(action.payload.sortQuestion)) === 2) {
                state.dataAnswersIdForType2 = action.payload.answer;
                }
                if ((Number(action.payload.sortQuestion)) === 3) {
                state.dataAnswersIdForType3 = action.payload.answer;
                }
                if ((Number(action.payload.sortQuestion)) === 4) {
                state.dataAnswersIdForType4 = action.payload.answer;
                }

            }
            state.isFetching = true;
            state.error= false;
        })
        .addCase(idAnswersLoad.rejected, (state, action) => {
            state.isFetching = false;
            state.error = action.payload; 
            console.log("oh wrong!!!");
        })
                
         //UPDATE ID ANSWERS
         .addCase(idAnswersUpdate.pending, (state, action) => {
            state.isFetching = true;
            state.error = false;
        })
        .addCase(idAnswersUpdate.fulfilled, (state, action) => {
            if (action.payload) {
                state.dataAnswersId_1 = action.payload;
                

                state.dataAnswersId.map(item => {
                    if ( item.id === action.payload.answer_id) {
                        item.text = action.payload.answer_content;
                        item.value = action.payload.answer_value;
                        item.feedback = action.payload.answer_feedback;
                    } else return null;
                    return item;
                });
            }
            state.openInputForms = false;
            state.isFetching = true;
            state.error= false;
        })
        .addCase(idAnswersUpdate.rejected, (state, action) => {
            state.isFetching = false;
            state.error = action.payload;
            console.log("oh wrong!!!");
        })
         //UPDATE ID ANSWERS TYPE2
         .addCase(idAnswersUpdateType2.pending, (state, action) => {
            state.isFetching = true;
            state.error = false;
        })
        .addCase(idAnswersUpdateType2.fulfilled, (state, action) => {
            if (action.payload) {
                             

                state.dataAnswersIdForType2.map(item => {
                    if ( item.answer_id === action.payload.answer_id) {
                        item.content = action.payload.content;
                        item.answer_order = action.payload.answer_order;
                        
                    } else return null;
                    return item;
                });
            }
            state.openInputFormsForAnswersType2 = false;
            state.isFetching = true;
            state.error= false;
        })
        .addCase(idAnswersUpdateType2.rejected, (state, action) => {
            state.isFetching = false;
            state.error = action.payload;
            console.log("oh wrong!!!");
        })
                //UPDATE ID ANSWERS TYPE 3
         .addCase(idAnswersUpdateType3.pending, (state, action) => {
            state.isFetching = true;
            state.error = false;
        })
        .addCase(idAnswersUpdateType3.fulfilled, (state, action) => {
            if (action.payload) {
                             

                state.dataAnswersIdForType3.map(item => {
                    if ( item.answer_id === action.payload.answer_id) {
                        item.content = action.payload.content;
                        item.answer_right = action.payload.answer_right;
                        
                    } else return null;
                    return item;
                });
            }
            state.openInputFormsForAnswersType3 = false;
            state.isFetching = true;
            state.error= false;
        })
        .addCase(idAnswersUpdateType3.rejected, (state, action) => {
            state.isFetching = false;
            state.error = action.payload;
            console.log("oh wrong!!!");
        })
                       //UPDATE ID ANSWERS TYPE 4
         .addCase(idAnswersUpdateType4.pending, (state, action) => {
            state.isFetching = true;
            state.error = false;
        })
        .addCase(idAnswersUpdateType4.fulfilled, (state, action) => {
            if (action.payload) {
                             

                state.dataAnswersIdForType4.map(item => {
                    if ( item.answer_id === action.payload.answer_id) {
                        item.content_source = action.payload.content_source;
                        item.content_compare = action.payload.content_compare;
                        
                    } else return null;
                    return item;
                });
            }
            state.openInputFormsForAnswersType4 = false;
            state.isFetching = true;
            state.error= false;
        })
        .addCase(idAnswersUpdateType4.rejected, (state, action) => {
            state.isFetching = false;
            state.error = action.payload;
            console.log("oh wrong!!!");
        })
         //UPDATE ID QUESTIONS
         .addCase(idQuestionUpdate.pending, (state, action) => {
            state.isFetching = true;
            state.error = false;
        })
        .addCase(idQuestionUpdate.fulfilled, (state, action) => {
            if (action.payload) {
           state.dataQuestionsId.map(item => {
                if ( item.id === action.payload.question_id) {
                    item.text = action.payload.question_content;
                    item.sortQuestion = action.payload.sort_quest;
                } else return null;
                return item;
            });
        }
            state.openInputFormsForQuestions = false;
            state.isFetching = true;
            state.error= false;
        })
        .addCase(idQuestionUpdate.rejected, (state, action) => {
            state.isFetching = false;
            state.error = action.payload;
            console.log("oh wrong!!!");
        })
       
                 //UPDATE ID QUIZES
        .addCase(idQuizUpdate.pending, (state, action) => {
            state.isFetching = true;
            state.error = false;
        })
        .addCase(idQuizUpdate.fulfilled, (state, action) => {
            if (action.payload) {
          state.dataQuizesId.map(item => {
                if ( item.id === action.payload.quiz_id) {
                    item.text = action.payload.quiz_name;
                    item.quiz_description = action.payload.quiz_description;
                } else return null;
                return item;
            });
        }
            state.openInputFormsForQuizes = false;
            state.isFetching = true;
            state.error= false;
        })
        .addCase(idQuizUpdate.rejected, (state, action) => {
            state.isFetching = false;
            state.error = action.payload;
            console.log("oh wrong!!!");
        })
         //UPDATE ID SUBCATEGORIES
         .addCase(idSubCategoriesUpdate.pending, (state, action) => {
            state.isFetching = true;
            state.error = false;
        })
        .addCase(idSubCategoriesUpdate.fulfilled, (state, action) => {
                if (action.payload) {
            state.dataSubCategoryId.map(item => {
                if ( item.id === action.payload.sub_id) {
                    item.text = action.payload.sub_name;
                 } else return null;
                 return item;
            });
        }
            state.openInputFormsForSubCategories = false;
            state.isFetching = true;
            state.error= false;
        })
        .addCase(idSubCategoriesUpdate.rejected, (state, action) => {
            state.isFetching = false;
            state.error = action.payload;
            console.log("oh wrong!!!");
        })
        //UPDATE ID CATEGORIES
        .addCase(idCategoriesUpdate.pending, (state, action) => {
            state.isFetching = true;
            state.error = false;
        })
        .addCase(idCategoriesUpdate.fulfilled, (state, action) => {
            if (action.payload) {
         state.dataCategories.map(item => {
                if ( item.id === action.payload.main_id) {
                    item.label = action.payload.main_name;
                 } else return null;
                 return item;
            });
        }
            state.openInputFormsForCategories = false;
            state.isFetching = true;
            state.error= false;
        })
        .addCase(idCategoriesUpdate.rejected, (state, action) => {
            state.isFetching = false;
            state.error = action.payload;
            console.log("oh wrong!!!");
        })

         //CREATE ID ANSWERS
         .addCase(idAnswersCreate.pending, (state, action) => {
            state.isFetching = true;
            state.error = false;
        })
        .addCase(idAnswersCreate.fulfilled, (state, action) => {
            if (action.payload) {
         state.dataAnswersId.push({id: action.payload.answer_id, text:action.payload.answer_content, feedback:action.payload.answer_feedback, value:action.payload.answer_value});
                 
            }
            state.openAddInputFormsForAnswers = false;
            state.isFetching = true;
            state.error= false;
        })
        .addCase(idAnswersCreate.rejected, (state, action) => {
            state.isFetching = false;
            state.error = action.payload;
            console.log("oh wrong!!!");
        }) 
                 //CREATE ID ANSWERS FOR TYPE 2
         .addCase(idAnswersCreateType2.pending, (state, action) => {
            state.isFetching = true;
            state.error = false;
        })
        .addCase(idAnswersCreateType2.fulfilled, (state, action) => {
            if (action.payload) {
         state.dataAnswersIdForType2.push({
            answer_id: action.payload.answer_id, 
            content:action.payload.content,  
            answer_order:action.payload.answer_order, 
            question_id:action.payload.question_id});
                 
            }
            state.openAddInputFormsForAnswersType2 = false;
            state.isFetching = true;
            state.error= false;
        })
        .addCase(idAnswersCreateType2.rejected, (state, action) => {
            state.isFetching = false;
            state.error = action.payload;
            console.log("oh wrong!!!");
        }) 
                         //CREATE ID ANSWERS FOR TYPE 3
         .addCase(idAnswersCreateType3.pending, (state, action) => {
            state.isFetching = true;
            state.error = false;
        })
        .addCase(idAnswersCreateType3.fulfilled, (state, action) => {
            if (action.payload) {
         state.dataAnswersIdForType3.push({
            answer_id: action.payload.answer_id, 
            content:action.payload.content,  
            answer_right:action.payload.answer_right, 
            question_id:action.payload.question_id});
                 
            }
            state.openAddInputFormsForAnswersType3 = false;
            state.isFetching = true;
            state.error= false;
        })
        .addCase(idAnswersCreateType3.rejected, (state, action) => {
            state.isFetching = false;
            state.error = action.payload;
            console.log("oh wrong!!!");
        })
                                 //CREATE ID ANSWERS FOR TYPE 4
         .addCase(idAnswersCreateType4.pending, (state, action) => {
            state.isFetching = true;
            state.error = false;
        })
        .addCase(idAnswersCreateType4.fulfilled, (state, action) => {
            if (action.payload) {
         state.dataAnswersIdForType4.push({
            answer_id: action.payload.answer_id, 
            content_source:action.payload.content_source,
            content_compare:action.payload.content_compare,   
            
            question_id:action.payload.question_id});
                 
            }
            state.openAddInputFormsForAnswersType4 = false;
            state.isFetching = true;
            state.error= false;
        })
        .addCase(idAnswersCreateType4.rejected, (state, action) => {
            state.isFetching = false;
            state.error = action.payload;
            console.log("oh wrong!!!");
        })   
                //CREATE ID QUESTIONS
        .addCase(idQuestionsCreate.pending, (state, action) => {
            state.isFetching = true;
            state.error = false;
        })
        .addCase(idQuestionsCreate.fulfilled, (state, action) => {
            console.log(action.payload);
            if (action.payload) {
          state.dataQuestionsId.push({
            id: action.payload.question_id, 
            text:action.payload.question_content,
            question_img: action.payload.question_img,
            sort_quest: action.payload.sort_quest
        });
                 
            }
            state.openAddInputFormsForQuestions = false;
            state.isFetching = true;
            state.error= false;
        })

        .addCase(idQuestionsCreate.rejected, (state, action) => {
            state.isFetching = false;
            state.error = action.payload;
            console.log("oh wrong!!!");
        })        
        //CREATE ID QUZES
        .addCase(idQuizesCreate.pending, (state, action) => {
            state.isFetching = true;
            state.error = false;
        })
        .addCase(idQuizesCreate.fulfilled, (state, action) => {
            if (action.payload) {
            state.dataQuizesId.push({id: action.payload.quiz_id, text:action.payload.quiz_name,quiz_description:action.payload.quiz_description});
            }
            
            state.openAddInputFormsForQuizes = false;
            state.isFetching = true;
            state.error= false;
        })
        .addCase(idQuizesCreate.rejected, (state, action) => {
            state.isFetching = false;
            state.error = action.payload;
            console.log("oh wrong!!!");
        })       
                //CREATE ID CATEGORIES
        .addCase(idCategoriesCreate.pending, (state, action) => {
            state.isFetching = true;
            state.error = false;
        })
        .addCase(idCategoriesCreate.fulfilled, (state, action) => {
            if (action.payload) {

            state.dataCategories.push({id: action.payload.main_id, label:action.payload.main_name});
                 
            }
            state.openAddInputFormsForCategories = false;
            state.isFetching = true;
            state.error= false;
        })
        .addCase(idCategoriesCreate.rejected, (state, action) => {
            state.isFetching = false;
            state.error = action.payload;
            console.log("oh wrong!!!");
        })
        //CREATE ID SUBCATEGORIES
        .addCase(idSubCategoriesCreate.pending, (state, action) => {
            state.isFetching = true;
            state.error = false;
        })
        .addCase(idSubCategoriesCreate.fulfilled, (state, action) => {
            if (action.payload) {
            state.dataSubCategoryId.push({id: action.payload.sub_id, text:action.payload.sub_name});
            }
            state.openAddInputFormsForSubCategories = false;
            state.isFetching = true;
            state.error= false;
        })
        .addCase(idSubCategoriesCreate.rejected, (state, action) => {
            state.isFetching = false;
            state.error = action.payload;
            console.log("oh wrong!!!");
        })        
         //DELETE ID CATEGORIES
         .addCase(idCategoriesDelete.pending, (state, action) => {
            state.isFetching = true;
            state.error = false;
        })
        .addCase(idCategoriesDelete.fulfilled, (state, action) => {
            
                const index = state.dataCategories.findIndex(item => item.id === Number(state.selectedId));
                if (index !== -1) {
                    state.dataCategories.splice(index, 1);
                }
            
            state.openDeleteInputForms= false;
            state.isFetching = true;
            state.error= false;
        })
        .addCase(idCategoriesDelete.rejected, (state, action) => {
            state.isFetching = false;
            state.error = action.payload;
            console.log("oh wrong!!!");
        })
        //DELETE ID SUBCATEGORIES
        .addCase(idSubCategoriesDelete.pending, (state, action) => {
            state.isFetching = true;
            state.error = false;
        })
        .addCase(idSubCategoriesDelete.fulfilled, (state, action) => {
         
            const index = state.dataSubCategoryId.findIndex(item => item.id === Number(state.selectedId));
            if (index !== -1) {
                state.dataSubCategoryId.splice(index, 1);
            }
            state.openDeleteInputFormsForSubCategories= false;
            state.isFetching = true;
            state.error= false;
        })
        .addCase(idSubCategoriesDelete.rejected, (state, action) => {
            state.isFetching = false;
            state.error = action.payload;
            console.log("oh wrong!!!");
        })

        //DELETE ID QUIZES
        .addCase(idQuizesDelete.pending, (state, action) => {
            state.isFetching = true;
            state.error = false;
        })
        .addCase(idQuizesDelete.fulfilled, (state, action) => {
         
            const index = state.dataQuizesId.findIndex(item => item.id === Number(state.selectedId));
            if (index !== -1) {
                state.dataQuizesId.splice(index, 1);
            }
            state.openDeleteInputFormsForQuizes= false;
            state.isFetching = true;
            state.error= false;
        })
        .addCase(idQuizesDelete.rejected, (state, action) => {
            state.isFetching = false;
            state.error = action.payload;
            console.log("oh wrong!!!");
        })





        
        //DELETE ID QUESTIONS
        .addCase(idQuestionsDelete.pending, (state, action) => {
            state.isFetching = true;
            state.error = false;
        })
        .addCase(idQuestionsDelete.fulfilled, (state, action) => {
         
            const index = state.dataQuestionsId.findIndex(item => item.id === Number(state.selectedId));
            if (index !== -1) {
                state.dataQuestionsId.splice(index, 1);
            }
            state.openDeleteInputFormsForQuestions= false;
            state.isFetching = true;
            state.error= false;
        })
        .addCase(idQuestionsDelete.rejected, (state, action) => {
            state.isFetching = false;
            state.error = action.payload;
            console.log("oh wrong!!!");
        })
                //DELETE IMG  QUESTION
        .addCase(imgQuestionDelete.pending, (state, action) => {
            state.isFetching = true;
            state.error = false;
        })
        .addCase(imgQuestionDelete.fulfilled, (state, action) => {
         
            const index = state.dataQuestionsId.findIndex(item => item.id === Number(state.selectedId));
            if (index !== -1) {
                state.dataQuestionsId[index].question_img = null;
                state.selectedImgName = "";
            }
           // state.openDeleteInputFormsForQuestions= false;
            state.isFetching = true;
            state.error= false;
        })
        .addCase(imgQuestionDelete.rejected, (state, action) => {
            state.isFetching = false;
            state.error = action.payload;
            console.log("oh wrong!!!");
        })
        //DELETE ID ANSWERS
        .addCase(idAnswersDelete.pending, (state, action) => {
            state.isFetching = true;
            state.error = false;
        })
        .addCase(idAnswersDelete.fulfilled, (state, action) => {
         
            if (Number(state.sortQuestion) === 1) {
                const index = state.dataAnswersId.findIndex(item => item.id === Number(state.selectedId));
                if (index !== -1) {
                    state.dataAnswersId.splice(index, 1);
                }
            }
            if (Number(state.sortQuestion) === 2) {
                console.log('delete from data of type 2');
                const index = state.dataAnswersIdForType2.findIndex(item => item.answer_id === Number(state.selectedId));
                if (index !== -1) {
                    state.dataAnswersIdForType2.splice(index, 1);
                }
            }
            if (Number(state.sortQuestion) === 3) {
                console.log('delete from data of type 3');
                const index = state.dataAnswersIdForType3.findIndex(item => item.answer_id === Number(state.selectedId));
                if (index !== -1) {
                    state.dataAnswersIdForType3.splice(index, 1);
                }
            }
            if (Number(state.sortQuestion) === 4) {
                console.log('delete from data of type 4');
                const index = state.dataAnswersIdForType4.findIndex(item => item.answer_id === Number(state.selectedId));
                if (index !== -1) {
                    state.dataAnswersIdForType4.splice(index, 1);
                }
            }
            state.openDeleteInputFormsForAnswers = false;
            state.isFetching = true;
            state.error= false;
        })
        .addCase(idAnswersDelete.rejected, (state, action) => {
            state.isFetching = false;
            state.error = action.payload;
            console.log("oh wrong!!!");
        })

        // UPLOAD NOTE PART
        .addCase(uploadNotePart.pending, (state) => {
            state.isFetching = true;
            state.error = false;
        })
        .addCase(uploadNotePart.fulfilled, (state, action) => {
            state.isFetching = true;
            console.log(action.payload);
           
            if (action.payload) {

            const newNote =(data) => {
                return {
                    id: data[0].note_id,
                    content: data
                }
            }

            
            const index = state.dataNotes.findIndex(item => item.id === Number(action.payload[0].note_id));
            if (index !== -1) {
                console.log("delete note existed");
                state.dataNotes.splice(index, 1);
                // add new note
                state.dataNotes.push(newNote(action.payload));
            } else {
                state.dataNotes.push(newNote(action.payload));
            }
        }




            //state.dataNotes.push(newNote(action.payload));



            state.error= false;
        })
        .addCase(uploadNotePart.rejected, (state, action) => {
            state.isFetching = false;
            state.error= action.payload;
        })
                // UPLOAD  ADD NOTE FILES
        .addCase(uploadAddNoteFiles.pending, (state) => {
            state.isFetching = true;
            state.error = false;
        })
        .addCase(uploadAddNoteFiles.fulfilled, (state, action) => {
            state.isFetching = true;
            console.log(action.payload);
                  if (action.payload) { 

                    state.noteAddFiles.push(action.payload);

                  }    



            state.error= false;
        })
        .addCase(uploadAddNoteFiles.rejected, (state, action) => {
            state.isFetching = false;
            state.error= action.payload;
        })

        // GET NOTE ID
        .addCase(idNoteLoad.pending, (state) => {
            state.isFetching = true;
            state.error = false;
        })
        .addCase(idNoteLoad.fulfilled, (state, action) => {
          //  console.log('FULLFILED NOTE!!');
            state.isFetching = true;
           // console.log(action.payload);
        if (action.payload) {   
            if (action.payload["notes"] ) {


                const newNote =(data) => {
                    return {
                        id: data[0].note_id,
                        content: data
                    }
                }
                    // check if exist and delete if exist
                const index = state.dataNotes.findIndex(item => item.id === Number(action.payload["notes"][0].note_id));
                if (index !== -1) {
                    console.log("delete note existed");
                    state.dataNotes.splice(index, 1);
                    // add new note
                    state.dataNotes.push(newNote(action.payload["notes"]));
                } else {
                    state.dataNotes.push(newNote(action.payload["notes"]));
                }
                //console.log(newNote);
            }
            if (action.payload["troubles"]) {
                state.dataTroubles = action.payload["troubles"];
            }
            if (action.payload["answers"]) {
                state.dataAnswerTroubles = action.payload["answers"];
            }
        } 


            state.error= false;
        })
        .addCase(idNoteLoad.rejected, (state, action) => {
            state.isFetching = false;
            state.error= action.payload;
        })
              /*  // GET PDF
        .addCase(pdfLoad.pending, (state) => {
            state.isFetching = true;
            state.error = false;
        })
        .addCase(pdfLoad.fulfilled, (state, action) => {
          //  console.log('FULLFILED NOTE!!');
            state.isFetching = true;
           // console.log(action.payload);
        if (action.payload) {   
           state.pdfName = action.payload;
        }

            state.error= false;
        })
        .addCase(pdfLoad.rejected, (state, action) => {
            state.isFetching = false;
            state.error= action.payload;
        })*/
        // GET NOTE ID ADD FILES
        .addCase(idNoteAddFilesLoad.pending, (state) => {
            state.isFetching = true;
            state.error = false;
        })
        .addCase(idNoteAddFilesLoad.fulfilled, (state, action) => {
          //  console.log('FULLFILED NOTE!!');
            state.isFetching = true;
           // console.log(action.payload);
        if (action.payload) {  
            state.noteAddFiles = action.payload;
           
        } else {
            state.noteAddFiles = [];
            console.log('NO NOTE ADD FILES ');}


            state.error= false;
        })
        .addCase(idNoteAddFilesLoad.rejected, (state, action) => {
            state.isFetching = false;
            state.error= action.payload;
        })
        //DELETE IMAGE NOTE PART

         .addCase(noteImagePartDelete.pending,(state) => {
            state.isFetching = true;
            state.error = false;
         }) 
         .addCase(noteImagePartDelete.fulfilled, (state, action) => {
            state.isFetching = true;
            console.log(action.payload);
            
            console.log(action.payload);
            //console.log(action.payload.note_id);
            if (action.payload.length !== 0 ) {
                
                const newNote =(data) => {
                    return {
                        id: data[0].note_id,
                        content: data
                    }
                }
            
                    // check if exist and delete if exist
                const index = state.dataNotes.findIndex(item => item.id === Number(action.payload[0].note_id));
                if (index !== -1) {
                    console.log("delete note existed");
                    state.dataNotes.splice(index, 1);
                    // add new note
                    state.dataNotes.push(newNote(action.payload));
                } else {
                    state.dataNotes.push(newNote(action.payload));
                }
            } else {
                const index = state.dataNotes.findIndex(item => item.id === Number(state.selectedIdNote));
                if (index !== -1) {
                    console.log("delete note existed");
                    state.dataNotes.splice(index, 1);
                }
            
            }
        })
         .addCase(noteImagePartDelete.rejected, (state, action) => {
            state.isFetching = false;
            state.error = action.payload;
         }) 
         
          //DELETE  NOTE PART

          .addCase(notePartDelete.pending,(state) => {
            state.isFetching = true;
            state.error = false;
         }) 
         .addCase(notePartDelete.fulfilled, (state, action) => {
            state.isFetching = true;
            //console.log(action.payload);
            
            console.log(action.payload);
            //console.log(action.payload.note_id);
            if (action.payload) {

                if (action.payload.length !== 0 ) {
                    
                    const newNote =(data) => {
                        return {
                            id: data[0].note_id,
                            content: data
                        }
                    }
                
                        // check if exist and delete if exist
                    const index = state.dataNotes.findIndex(item => item.id === Number(action.payload[0].note_id));
                    if (index !== -1) {
                        console.log("delete note existed");
                        state.dataNotes.splice(index, 1);
                        // add new note
                        state.dataNotes.push(newNote(action.payload));
                    } else {
                        state.dataNotes.push(newNote(action.payload));
                    }
                } else {
                    const index = state.dataNotes.findIndex(item => item.id === Number(state.selectedIdNote));
                    if (index !== -1) {
                        console.log("delete note existed");
                        state.dataNotes.splice(index, 1);
                    }
                
                }
            }
        })
         .addCase(notePartDelete.rejected, (state, action) => {
            state.isFetching = false;
            state.error = action.payload;
         })
                   //DELETE  ADD FILE

          .addCase(addFileDelete.pending,(state) => {
            state.isFetching = true;
            state.error = false;
         }) 
         .addCase(addFileDelete.fulfilled, (state, action) => {
            state.isFetching = true;
            //console.log(action.payload);
            
            console.log(action.payload);
            //console.log(action.payload.note_id);
            if (action.payload) {

                if (action.payload) {
                    if (action.payload.length === 0 ) {
                    const index = state.noteAddFiles.findIndex(item => item.id === Number(state.selectedIdAddFile));
                    
                    console.log(index);

                    if (index !== -1) {
                        console.log('delete addfile from state');
                        state.noteAddFiles.splice(index, 1);
                    }
                    }
                }
            }
        })
         .addCase(addFileDelete.rejected, (state, action) => {
            state.isFetching = false;
            state.error = action.payload;
         })
         
         // EDIT NOTE PART
        .addCase(editNotePart.pending, (state) => {
            state.isFetching = true;
            state.error = false;
        })
        .addCase(editNotePart.fulfilled, (state, action) => {
            state.isFetching = true;
            console.log(action.payload);
            if (action.payload===500) { 
                console.log('SERVERR 500!!');
            }

            if (action.payload) {
            const newNote =(data) => {
                return {
                    id: data[0].note_id,
                    content: data
                }
            }

            
            const index = state.dataNotes.findIndex(item => item.id === Number(action.payload[0].note_id));
            if (index !== -1) {
                console.log("delete note existed");
                state.dataNotes.splice(index, 1);
                // add new note
                state.dataNotes.push(newNote(action.payload));
            } else {
                state.dataNotes.push(newNote(action.payload));
            }

        }



            //state.dataNotes.push(newNote(action.payload));



            state.error= false;
        })
        .addCase(editNotePart.rejected, (state, action) => {
            state.isFetching = false;
            state.error= action.payload;
        })
        //ADD TROUBLE
        .addCase(idTroubleCreate.pending, (state, action) => {
            state.isFetching = true;
            state.error = false;
        })
        .addCase(idTroubleCreate.fulfilled, (state, action) => {
            if (action.payload) {
            //state.dataQuizes = action.payload;
            state.dataTroubles.push(action.payload);
                console.log(action.payload);
            }
            state.isFetching = true;
            state.error= false;
        })
        .addCase(idTroubleCreate.rejected, (state, action) => {
            state.isFetching = false;
            state.error = action.payload;
            console.log("oh wrong!!!");
        })
         //ADD ANSWER ON TROUBLE
         .addCase(idAnswerOnTroubleCreate.pending, (state, action) => {
            state.isFetching = true;
            state.error = false;
        })
        .addCase(idAnswerOnTroubleCreate.fulfilled, (state, action) => {
            if (action.payload) {
            //state.dataQuizes = action.payload;
            state.dataAnswerTroubles.push(action.payload);
                console.log(action.payload);
            }
            state.isFetching = true;
            state.error= false;
        })
        .addCase(idAnswerOnTroubleCreate.rejected, (state, action) => {
            state.isFetching = false;
            state.error = action.payload;
            console.log("oh wrong!!!");
        })
        //DELETE  ANSWER TROUBLE

          .addCase(answerTroubleDelete.pending,(state) => {
            state.isFetching = true;
            state.error = false;
         }) 
         .addCase(answerTroubleDelete.fulfilled, (state, action) => {
            state.isFetching = true;
            //console.log(action.payload);
            
            console.log(action.payload);
            //console.log(action.payload.note_id);
            if (action.payload) {

                if (action.payload) {
                    if (action.payload.length === 0 ) {
                    const index = state.dataAnswerTroubles.findIndex(item => item.answer_id === Number(state.selectedIdAnswerTrouble));
                    
                    console.log(index);

                    if (index !== -1) {
                        console.log('delete answer trouble from state');
                        state.dataAnswerTroubles.splice(index, 1);
                    }
                    }
                }
            }
        })
         .addCase(answerTroubleDelete.rejected, (state, action) => {
            state.isFetching = false;
            state.error = action.payload;
         })
 //DELETE  TROUBLE

          .addCase(troubleDelete.pending,(state) => {
            state.isFetching = true;
            state.error = false;
         }) 
         .addCase(troubleDelete.fulfilled, (state, action) => {
            state.isFetching = true;
            //console.log(action.payload);
            
            console.log(action.payload);
            //console.log(action.payload.note_id);
            if (action.payload) {

                if (action.payload) {
                    if (action.payload.length === 0 ) {
                    const index = state.dataTroubles.findIndex(item => item.trouble_id === Number(state.selectedIdTrouble));
                    
                    console.log(index);

                    if (index !== -1) {
                        console.log('delete answer trouble from state');
                        state.dataTroubles.splice(index, 1);
                    }
                    }
                }
            }
        })
         .addCase(troubleDelete.rejected, (state, action) => {
            state.isFetching = false;
            state.error = action.payload;
         })
         // ADD ANSWER RATE ON TROUBLE
        .addCase(addAnswerRateOnTrouble.pending, (state) => {
            state.isFetching = true;
            state.error = false;
        })
        .addCase(addAnswerRateOnTrouble.fulfilled, (state, action) => {
            state.isFetching = true;
            console.log(action.payload);

            if (action.payload) {
            
            const index = state.dataAnswerTroubles.findIndex(item => item.answer_id === Number(action.payload.result.answer_id));
            console.log(index);
            if (index !== -1) {
               // const newRate = action.payload.result.value_rate;
                const lastRate = action.payload.count_up;
                if (lastRate !== false){
                console.log(" set new rate on answer trouble");
                //state.dataAnswerTroubles[index].count_up ++;
                state.dataAnswerTroubles[index].count_up = action.payload.count_up;
                state.dataAnswerTroubles[index].count_down = action.payload.count_down;
                } 
                //else {
               // console.log("- rate on answer trouble");
               // state.dataAnswerTroubles[index].count_down --;
              //  return null;
                }
           // } 
            //else {
             //   return null;
           // }

        }

            state.error= false;
        })
        .addCase(addAnswerRateOnTrouble.rejected, (state, action) => {
            state.isFetching = false;
            state.error= action.payload;
        })
                //SET PUBLIC OPTION FOR SUBCATEGORY
        .addCase(setPublicOptionSubCategory.pending, (state, action) => {
            state.isFetching = true;
            state.error = false;
        })
        .addCase(setPublicOptionSubCategory.fulfilled, (state, action) => {
            if (action.payload) {
            const index =  state.dataSubCategoryId.findIndex(item => item.id === action.payload.sub_id);
          console.log(index);
            if (index !== -1) {
            state.dataSubCategoryId[index].public = action.payload.public;
           }
           
                console.log(action.payload);
            }
            state.isFetching = true;
            state.error= false;
        })
        .addCase(setPublicOptionSubCategory.rejected, (state, action) => {
            state.isFetching = false;
            state.error = action.payload;
            console.log("oh wrong!!!");
        })
                //SET PUBLIC OPTION FOR QUIZ
        .addCase(setPublicOptionQuiz.pending, (state, action) => {
            state.isFetching = true;
            state.error = false;
        })
        .addCase(setPublicOptionQuiz.fulfilled, (state, action) => {
            if (action.payload) {
          const index =  state.dataQuizesId.findIndex(item => item.id === action.payload.quiz_id);
           if (index !== -1) {
            state.dataQuizesId[index].public = action.payload.public;
           }
                console.log(action.payload);
            }
            state.isFetching = true;
            state.error= false;
        })
        .addCase(setPublicOptionQuiz.rejected, (state, action) => {
            state.isFetching = false;
            state.error = action.payload;
            console.log("oh wrong!!!");
        })
                       // UPLOAD  QUIZ IMG
                .addCase(uploadQuizImg.pending, (state) => {
                    state.isFetching = true;
                    state.error = false;
                })
                .addCase(uploadQuizImg.fulfilled, (state, action) => {
                    state.isFetching = true;
                    
                    if (action.payload) { 
                        console.log(action.payload);
                        const index =  state.dataQuestionsId.findIndex(item => item.id === action.payload.question_id);
                        if (index !== -1) {
                            state.dataQuestionsId[index].question_img = action.payload.question_img;
                        }
        
                          }    
        
        
        
                    state.error= false;
                })
                .addCase(uploadQuizImg.rejected, (state, action) => {
                    state.isFetching = false;
                    state.error= action.payload;
                })        

    }

};

export const adminSlice = createSlice(options);
export const {getInitialStateForAdmin, openAdminView, closeAdminView, openDeleteInputFormsForAnswers, openAddInputFormsForAnswers, 
    openAddInputFormsForQuestions, openDeleteInputFormsForQuestions, openDeleteInputFormsForQuizes, 
    openAddInputFormsForQuizes, openDeleteInputFormsForSubCategories, openAddInputFormsForCategories,
    openAddInputFormsForSubCategories, openDeleteInputForms, openInputForms, openInputFormsForQuestions, 
    openInputFormsForQuizes,openInputFormsForSubCategories, openInputFormsForCategories, closeInputForms, 
    getIdSelectedCategory, getIdSelectedSubCategory, 
    getIdSelectedQuize, getIdSelectedQuestion, openInputFormsForNote, closeInputFormsForNote, 
    activateAdminNoteView, errorNoteImageValidateSize, errorNoteImageValidateType,
    validateNoteImageSize, validateNoteImageType, addSelectedPartNote, openDeleteInputFormsForImageNotePart, 
    openDeleteInputFormsForNotePart, addDeletedImgPathPartNote, closeAdminNoteView, activateEditAdminNoteView,
    setImageFileForNotePart, closeAdminFoldererView, changeAdminFoldererView, changeAdminPdfView, closeAdminPdfView,
    setPdfFileName, openDeleteInputFormsForAddFile, closeDeleteInputFormsForAddFile, validateAddFileSize,validateAddFileType,
    setSelectedIdAnswerTrouble, setSelectedIdTrouble, clearErrorsValidateAddFile, setAdminDataTaskView, 
    closeAdminDataTaskView, validateQuizImageType, validateQuizImageSize, openPreviewQuestionImgForms,
    closePreviewQuestionImgForms, openDeleteInputFormsForQuestionsImg, closeDeleteInputFormsForQuestionsImg, 
    openAddInputFormsForAnswersType2, openAddInputFormsForAnswersType3, openAddInputFormsForAnswersType4,
    openInputFormsForAnswersType2, openInputFormsForAnswersType3, openInputFormsForAnswersType4, setInitialStateQuestions
} = adminSlice.actions;
export default adminSlice.reducer;



/*
        {
            id:41,
            title:"Минимальное расстояние между стержнями",
            content: [{part:1,text:`Минимальные расстояния в свету между стержнями арматуры следует принимать такими,
            чтобы обеспечить совместную работу арматуры с бетоном и качественное изготовление конструкций,
            связанное с укладкой и уплотнением бетонной смеси, но не менее наибольшего диаметра стержня, а
            также не менее:25 мм — при горизонтальном или наклонном положении стержней при бетонировании — для нижней арматуры, расположенной в один или два ряда;
            30 мм — то же для верхней арматуры; 50 мм — то же при расположении нижней арматуры более чем в два ряда (кроме стержней двух
            нижних рядов), а также при вертикальном положении стержней при бетонировании.
            `,img_path:"n_41_1_note_934525b5-258c-4052-8540-425fd592e290.jpg",img_text:"Рис. Минимальные расстояния между стержнями"},
            {part:2,text:"Рис ",img_path:"",img_text:`50 мм — то же при расположении нижней арматуры более чем в два ряда (кроме стержней двух
                нижних рядов), а также при вертикальном положении стержней при бетонировании`},
            {part:3,text:"вапвапппппппппппппппппппппыавпку авпрвапрвапр вар вар вр",img_path:"n_41_3_note_d39c7111-a5f7-44b4-8eb4-1f4e36131766.jpg",img_text:`рис всякая фигня`}]
            
           
        }*/